<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <div class="mb-2">
                  <span>My Teams IDP</span>
                  <span class="text-muted ml-2"></span>
                  <span class="text-danger ml-2">{{ activeTabTitle }}</span>
                </div>

                <p class="text-muted mb-md-0">This is My Teams IDP menu</p>
              </div>
            </div>
          </div>
        </div>
        <!-- My IDP dll -->
        <div class="card mt-5">
          <div class="card-header">
            <span class="mt-3 fs-2">My Teams IDP</span>
            <!-- <b-button
              v-if="
                currentTab === 1 &&
                listTabMenu &&
                listTabMenu.tabMenu?.some(
                  (item) =>
                    item.title === 'Strcutured Learning' &&
                    item.privilages.create
                )
              "
              class="btn btn-primary"
              variant="primary"
              @click="showAddTraining">
              <span class="fe fe-plus-circle"></span>
              Add Training
            </b-button> -->
            <b-button
              class="btn btn-primary mx-2"
              variant="primary"
              @click="showReportModal"
              v-if="currentTab !== 4 && listTabMenu"
            >
              <span class="fe fe-download"></span>
              Report
            </b-button>
            <b-button
              v-if="currentTab === 2 && isLoadingBulkApprove == false"
              class="btn btn-primary mx-2"
              variant="primary"
              @click="bulkApproved"
            >
              <span class="fe fe-save"></span>
              Bulk Approved
            </b-button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-if="currentTab === 2 && isLoadingBulkApprove == true"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </button>
          </div>
          <b-tabs v-model="currentTab" class="px-4">
            <b-tab title="Progress Summary" disabled>
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="text-center">
                      <th rowspan="2">No</th>
                      <th rowspan="2">Competency Group/Competency</th>
                      <th colspan="3">Learning Progress</th>
                      <th rowspan="2">Status</th>
                    </tr>
                    <tr class="text-center">
                      <th colspan="1">Structure Learning</th>
                      <th colspan="1">Social Learning</th>
                      <th colspan="1">Experiential Learning</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in summary" :key="index">
                      <td :class="{ 'fw-bold': item.isBold }" class="text-center">
                        {{ item.no }}
                      </td>
                      <td :class="{ 'fw-bold': item.isBold }">
                        {{ item.isBehaviour ? "- " + item.competency : item.competency }}
                      </td>
                      <td class="text-center">
                        {{ item.structureLearning }}
                      </td>
                      <td class="text-center">
                        {{ item.socialLearning }}
                      </td>
                      <td class="text-center">
                        {{ item.experientialLearning }}
                      </td>
                      <td class="text-center">
                        <span :class="getBadgeSummary(item.status)">{{ item.status }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab
              title="Structured Learning"
              v-if="
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Strcutured Learning' && item.privilages.read)
              "
            >
              <div class="col-lg-12 mt-5">
                <div class="row mt-4">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Name</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="employeeStructuredLearning"
                      :options="ListEmployeeStructuredLearning"
                      :reduce="(e) => e"
                      label="employee_name"
                      placeholder="Select Employee"
                      @input="selectEmployeestructuredLearning"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>NIK</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ nikStructuredLearning || "-" }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Posistion</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ positionStructuredLearning || "-" }}
                  </div>
                </div>
              </div>
              <div class="ml-4" v-if="employeeStructuredLearning != ''">
                <div class="row mt-5">
                  <div class="col-12 col-lg-6 col-xl">
                    <!-- Value  -->
                    <div class="card bg-secondary text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <!-- Title -->
                            <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.structuredCount?.planned
                                  ? personalData?.data?.structuredCount.planned
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-warning">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.structuredCount?.in_progress
                                  ? personalData?.data?.structuredCount.in_progress
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-success text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.structuredCount?.completed
                                  ? personalData?.data?.structuredCount.completed
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl" v-b-tooltip.hover="'Total approved hours / Total minimal hours'">
                    <div class="card bg-info text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">Total Learning Hours</h6>
                            <span class="h2 mb-0">
                              {{ personalData?.data?.count?.total_hours ? personalData?.data?.count.total_hours : 0 }}
                              /
                              {{ personalData?.data?.count?.min_hours ? personalData?.data?.count.min_hours : 0 }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl" v-b-tooltip.hover="'Total completed hours / Total approved hours'">
                    <div class="card bg-primary text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">Certification Learning Hour</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.count?.total_completed_hours
                                  ? personalData?.data?.count.total_completed_hours
                                  : 0
                              }}
                              /
                              {{ personalData?.data?.count?.total_hours ? personalData?.data?.count.total_hours : 0 }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="row align-items-center gx-0">
                      <div class="col-12 col-lg-12">
                        <apexchart
                          type="radialBar"
                          :height="dimensionChart()"
                          :options="chartOption(1)"
                          :series="
                            totals(
                              personalData?.data?.structuredCount?.percentage
                                ? personalData?.data?.structuredCount?.percentage
                                : 0
                            )
                          "
                        ></apexchart>
                        <h3 class="text-center">Overall Fullfillment</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-flow mb-2 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Waiting Approval Manager
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Waiting Approval HR
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Enrolled Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-user-plus me-1"></i> Enrolled
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Review Status -->
                <span class="badge bg-info text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-eye me-1"></i> In Review
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>

                <!-- Arrow Icon -->
                <!-- <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i> -->

                <!-- Closed Status -->
                <!-- <span
                  class="badge bg-secondary text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-x me-1"></i> Closed
                </span> -->
              </div>
              <div class="row">
                <div class="col-8">
                  <div class="d-flex">
                    <div class="rectangle filled-target mt-3"></div>
                    <span class="ml-2 mt-2">: Proficiency Standard</span>
                    <div class="rectangle filled-achievement mt-3 ml-3"></div>
                    <span class="ml-2 mt-2">: Proficiency</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3">
                  <v-select
                    v-model="filter_competency_struckture"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_type_struckture"
                    :options="['Certification', 'Semi Certification', 'Training']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Type"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_platform_struckture"
                    :options="['Ugems University', 'My Learning', 'Other']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Platform"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <input type="text" class="form-control" v-model="searchStructure" placeholder="Search..." />
                </div>
              </div>
              <div class="table overflow-scroll">
                <div v-if="isLoading" class="text-center my-4">
                  <span class="spinner-border" role="status" aria-hidden="true"></span>
                  <span>Loading...</span>
                </div>
                <table v-else class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <!-- log data -->
                    <!-- {{
                      structuredLearning
                    }} -->
                    <tr class="">
                      <th>
                        <input type="checkbox" @click="changeAllStructur" v-model="checkStructured" />
                      </th>
                      <!-- <th rowspan="2">Employee Name</th> -->
                      <th rowspan="2">Training Title</th>
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Level</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">Learning Type</th>
                      <th rowspan="2">Platform</th>
                      <th rowspan="2">Provider</th>
                      <th rowspan="2">Price</th>
                      <th rowspan="2">Hour</th>
                      <th class="text-center" rowspan="2">Status</th>
                      <!-- <th rowspan="2">Proposed By</th>
                      <th colspan="2" class="text-center">Schedule</th>
                      <th rowspan="2">Score</th> -->
                      <th rowspan="2">Action</th>
                    </tr>
                    <!-- <tr class="">
                      <th colspan="1">Start Date</th>
                      <th colspan="1">End Date</th>
                    </tr> -->
                  </thead>
                  <!-- <tbody
                    v-if="structuredLearning &&
                      structuredLearning.some(
                        (item) => item.training_title !== null
                      )
                    "
                  > -->
                  <tbody v-if="structuredLearning && structuredLearning.length">
                    <tr v-for="(item, index) in structuredLearning" :key="index">
                      <td class="">
                        <input
                          type="checkbox"
                          v-if="isCheckboxVisible(item.status) && item.training_title !== null && item.isAllowedAction"
                          @click="changeOnceCheckboxStructured(item)"
                          v-model="sRowStructured"
                          :value="item.id"
                        />
                      </td>
                      <!-- <td class="fw-bold">
                        {{ item.employee_nik }}
                      </td> -->
                      <td class="">
                        {{ item.training_title }}
                      </td>
                      <td v-if="item.competency !== null">
                        {{ item.competency }}
                      </td>
                      <td class="fw-bold" v-else></td>
                      <td v-if="item.competency">
                        <div class="rectangle-container">
                          <div
                            v-for="n in 5"
                            :key="'proficiency_standard-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-target': n <= item.proficiency_standard,
                              },
                            ]"
                          ></div>
                        </div>
                        <div class="rectangle-container mt-1">
                          <div
                            v-for="n in 5"
                            :key="'proficiency-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-achievement': n <= item.proficiency,
                              },
                            ]"
                          ></div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td v-if="item.competency">
                        <span v-if="item.difference !== null" :class="getBadgeGap(item.difference)">
                          {{ Math.abs(item.difference) }}
                        </span>
                      </td>
                      <td v-else></td>
                      <td class="">
                        {{ item.training_type }}
                      </td>
                      <td class="">
                        {{ item.training_platform }}
                      </td>
                      <td class="">
                        {{ item.training_provider }}
                      </td>
                      <td class="text-center">
                        <span v-if="item.training_price !== null">
                          {{ item.training_currency }}
                          {{ formatterNumber(item.training_price) }}
                        </span>
                        <span v-else></span>
                      </td>
                      <!-- <td class="">
                        {{ item.proposed_by }}
                      </td>
                      <td class="">
                        {{ item.startDate }}
                      </td>
                      <td class="">
                        {{ item.endDate }}
                      </td>
                      <td class="">
                        {{ item.score }}
                      </td> -->
                      <td class="text-center">
                        {{ item.training_hours }}
                      </td>
                      <td class="text-center">
                        <h2 v-if="item.training_title !== null">
                          <span :class="getBadgeStatus(item.status)">
                            <i :class="getIconClass(item.status)" class="me-1"></i>
                            {{ modifyStatus(item.status) }}
                          </span>
                        </h2>
                        <span v-else></span>
                      </td>
                      <td class="text-center">
                        <span> </span>
                        <button
                          v-if="
                            item.training_title !== null &&
                            item.status !== null &&
                            listTabMenu &&
                            listTabMenu.tabMenu?.some((item) => item.title === 'Strcutured Learning' && item.privilages.read)
                          "
                          class="btn btn-sm btn-info mx-2"
                          @click="viewDetailStructured(item)"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <!-- v-if="item.status === 'Completed'" -->
                        <!-- && item.status === 'completed' -->
                        <!-- <button
                          v-if="
                            item.status !== null &&
                            item.status === 'completed'
                          "
                          class="btn btn-sm btn-success mx-2"
                          @click="addScoreStructured(item)"
                          v-b-tooltip.hover="'Add Score'">
                          <span class="fe fe-award"></span>
                        </button> -->
                        <button v-if="item.status === 'Completed'" class="btn btn-sm btn-info mx-2">
                          <span class="fe fe-upload"></span>
                        </button>
                        <button v-if="item.status === 'Registered'" class="btn btn-sm btn-primary mx-2">
                          <span class="fe fe-rotate-ccw"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
                <p class="mt-3">
                  <i> Note: If checked, it will be approved. If unchecked, it will be rejected. </i>
                </p>
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center mt-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageStructure"
                    :disabled="currentPageStructure === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageStructure }} of {{ totalPagesStructure }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageStructure"
                    :disabled="currentPageStructure === totalPagesStructure || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageStructure"
                    @change="changePageSizeStructured(itemsPerPageStructure)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="float-end mb-4">
                <b-button
                  v-if="structuredLearning && structuredLearning.some((item) => item.training_title !== null)"
                  @click="submitStructured()"
                  variant="primary"
                >
                  <span class="fe fe-save"></span>
                  Approve
                </b-button>
                <!-- <b-button
                  v-else
                  @click="initStructuredLearning()"
                  variant="primary"
                  ><span class="fe fe-info"></span>
                  Get Recommendations
                </b-button> -->
              </div>
            </b-tab>
            <b-tab
              title="Social Learning"
              v-if="
                listTabMenu && listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.read)
              "
            >
              <div class="col-lg-12 mt-5">
                <div class="row mt-4">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Name</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="employeeSocial"
                      :options="ListEmployeeSocial"
                      :reduce="(e) => e"
                      label="employee_name"
                      placeholder="Select Employee"
                      @input="selectEmployeeSocial"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>NIK</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ nikSocial || "-" }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Posistion</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ positionSocial || "-" }}
                  </div>
                </div>
              </div>
              <div class="ml-4" v-if="employeeSocial != ''">
                <div class="row mt-5">
                  <div class="col-12 col-lg-6 col-xl">
                    <!-- Value  -->
                    <div class="card bg-secondary text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <!-- Title -->
                            <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>
                            <span class="h2 mb-0">
                              {{ personalData?.data?.socialCount?.planned ? personalData?.data?.socialCount.planned : 0 }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-warning">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.socialCount?.in_progress
                                  ? personalData?.data?.socialCount.in_progress
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-success text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.socialCount?.completed ? personalData?.data?.socialCount.completed : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="row align-items-center gx-0">
                      <div class="col-12 col-lg-12">
                        <apexchart
                          type="radialBar"
                          :height="dimensionChart()"
                          :options="chartOption(1)"
                          :series="
                            totals(
                              personalData?.data?.socialCount?.percentage ? personalData?.data?.socialCount?.percentage : 0
                            )
                          "
                        ></apexchart>
                        <h3 class="text-center">Overall Fullfillment</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-flow mb-1 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-send me-1"></i> Submitted
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Approved
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Scheduled -->
                <span class="badge bg-warning text-black px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Scheduled
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Progress Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-loader me-1"></i> In Progress
                </span>
                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Review Status -->
                <span class="badge bg-info text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-eye me-1"></i> In Review
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>
              </div>
              <div class="row">
                <div class="col-5">
                  <div class="d-flex">
                    <div class="rectangle filled-target mt-3"></div>
                    <span class="ml-2 mt-2">: Proficiency Standard</span>
                    <div class="rectangle filled-achievement mt-3 ml-3"></div>
                    <span class="ml-2 mt-2">: Proficiency</span>
                  </div>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_competency_social"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpSocial"
                  >
                  </v-select>
                </div>
                <div class="col-2">
                  <v-select
                    v-model="filter_type_social"
                    :options="['Coaching', 'Mentoring']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Type"
                    @input="getDataIdpSocial"
                  >
                  </v-select>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="searchSocial" placeholder="Search..." />
                </div>
              </div>
              <div class="table overflow-scroll">
                <div v-if="isLoading" class="text-center my-4">
                  <span class="spinner-border" role="status" aria-hidden="true"></span>
                  <span>Loading...</span>
                </div>
                <table v-else class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <!-- log data -->
                    <!-- {{
                      socialLearning
                    }} -->
                    <tr class="">
                      <th>
                        <input type="checkbox" @click="changeAllSocial" v-model="checkSocial" />
                      </th>
                      <!-- <th rowspan="2">Employee Name</th> -->
                      <th rowspan="2">Coaching Title</th>
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Level</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">Methodology</th>
                      <th rowspan="2">Coach Name</th>
                      <!-- <th rowspan="2">Coaching Title</th> -->
                      <!-- <th rowspan="2">Learning Type</th>
                      <th rowspan="2">Provider</th>
                      <th rowspan="2">Price</th> -->
                      <th rowspan="2">Type</th>
                      <th rowspan="2">Status</th>
                      <!-- <th rowspan="2">Proposed By</th>
                      <th colspan="2" class="text-center">Schedule</th>
                      <th rowspan="2">Score</th> -->
                      <th rowspan="2">Action</th>
                    </tr>
                    <!-- <tr class="">
                      <th colspan="1">Start Date</th>
                      <th colspan="1">End Date</th>
                    </tr> -->
                  </thead>
                  <!-- <tbody
                    v-if="
                      socialLearning &&
                      socialLearning.some(
                        (item) => item.coaching_title !== null
                      )
                    "> -->
                  <tbody v-if="socialLearning && socialLearning.length">
                    <tr v-for="(item, index) in socialLearning" :key="index">
                      <td class="">
                        <input
                          type="checkbox"
                          v-if="isCheckboxVisible(item.status) && item.coaching_title !== null"
                          @click="changeOnceCheckboxSocial(item)"
                          v-model="sRowSocial"
                          :value="item.id"
                        />
                      </td>
                      <!-- <td class="fw-bold">
                        {{ item.employee_name }}
                      </td> -->
                      <td class="">
                        {{ item.coaching_title }}
                      </td>
                      <td v-if="item.competency !== null">
                        {{ item.competency }}
                      </td>
                      <td class="fw-bold" v-else></td>
                      <td v-if="item.competency">
                        <div class="rectangle-container">
                          <div
                            v-for="n in 5"
                            :key="'proficiency_standard-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-target': n <= item.proficiency_standard,
                              },
                            ]"
                          ></div>
                        </div>
                        <div class="rectangle-container mt-1">
                          <div
                            v-for="n in 5"
                            :key="'proficiency-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-achievement': n <= item.proficiency,
                              },
                            ]"
                          ></div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td v-if="item.competency">
                        <span v-if="item.difference !== null" :class="getBadgeGap(item.difference)">
                          {{ Math.abs(item.difference) }}
                        </span>
                      </td>
                      <td v-else></td>

                      <td class="">
                        {{ item.coaching_methodology }}
                      </td>
                      <td class="">
                        {{ item.coach_name }}
                      </td>
                      <td class="">
                        {{ item.id ? item.coaching_type : "" }}
                      </td>
                      <td class="text-center">
                        <h2 v-if="item.status !== 'null' && item.coaching_title !== null">
                          <span :class="getBadgeStatus(item.status)">
                            <i :class="getIconClass(item.status)" class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </h2>
                        <span v-else></span>
                      </td>
                      <td class="text-center">
                        <span> </span>
                        <button
                          v-if="
                            item.coaching_title !== null &&
                            item.status !== null &&
                            listTabMenu &&
                            listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.read)
                          "
                          class="btn btn-sm btn-info mx-2"
                          @click="viewDetailSocial(item)"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <!-- v-if="item.status === 'Completed'" -->
                        <!-- && item.status === 'completed' -->
                        <!-- <button
                          v-if="
                            item.status !== null &&
                            item.status === 'completed'
                          "
                          class="btn btn-sm btn-success mx-2"
                          @click="addScoreSocial(item)"
                          v-b-tooltip.hover="'Add Score'">
                          <span class="fe fe-award"></span>
                        </button> -->
                        <button v-if="item.status === 'Completed'" class="btn btn-sm btn-info mx-2">
                          <span class="fe fe-upload"></span>
                        </button>
                        <button v-if="item.status === 'Registered'" class="btn btn-sm btn-primary mx-2">
                          <span class="fe fe-rotate-ccw"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
                <p class="mt-3">
                  <i> Note: If checked, it will be approved. If unchecked, it will be rejected. </i>
                </p>
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center mt-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageSocial"
                    :disabled="currentPageSocial === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageSocial }} of {{ totalPagesSocial }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageSocial"
                    :disabled="currentPageSocial === totalPagesSocial || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageStructure"
                    @change="changePageSizeStructured(itemsPerPageStructure)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="float-end mb-4">
                <b-button
                  v-if="socialLearning && socialLearning.some((item) => item.coaching_title !== null)"
                  @click="submitSocial()"
                  variant="primary"
                >
                  <span class="fe fe-save"></span>
                  Approve
                </b-button>
                <!-- <b-button
                  v-else
                  @click="initStructuredLearning()"
                  variant="primary"
                  ><span class="fe fe-info"></span>
                  Get Recommendations
                </b-button> -->
              </div>
            </b-tab>
            <b-tab
              title="Experiential Learning"
              v-if="
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Experiential Learning' && item.privilages.read)
              "
            >
              <div class="col-lg-12 mt-5">
                <div class="row mt-4">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Name</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="employeeExperiential"
                      :options="ListEmployeeExperiential"
                      :reduce="(e) => e"
                      label="employee_name"
                      placeholder="Select Employee"
                      @input="selectEmployeeExperiential"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>NIK</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ nikExperiential || "-" }}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Posistion</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    {{ positionExperiential || "-" }}
                  </div>
                </div>
              </div>
              <div class="ml-4" v-if="employeeExperiential != ''">
                <div class="row mt-5">
                  <div class="col-12 col-lg-6 col-xl">
                    <!-- Value  -->
                    <div class="card bg-secondary text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <!-- Title -->
                            <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.experentialCount?.planned
                                  ? personalData?.data?.experentialCount.planned
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-warning">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.experentialCount?.in_progress
                                  ? personalData?.data?.experentialCount.in_progress
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="card bg-success text-white">
                      <div class="card-body">
                        <div class="row align-items-center gx-0">
                          <div class="col">
                            <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>
                            <span class="h2 mb-0">
                              {{
                                personalData?.data?.experentialCount?.completed
                                  ? personalData?.data?.experentialCount.completed
                                  : 0
                              }}
                            </span>
                          </div>
                          <div class="col-auto">
                            <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 col-xl">
                    <div class="row align-items-center gx-0">
                      <div class="col-12 col-lg-12">
                        <apexchart
                          type="radialBar"
                          :height="dimensionChart()"
                          :options="chartOption(1)"
                          :series="
                            totals(
                              personalData?.data?.experentialCount?.percentage
                                ? personalData?.data?.experentialCount?.percentage
                                : 0
                            )
                          "
                        ></apexchart>
                        <h3 class="text-center">Overall Fullfillment</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-flow mb-2 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-send me-1"></i> Submitted
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Approved
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Progress Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-loader me-1"></i> In Progress
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>
              </div>
              <div class="row">
                <div class="col-6">
                  <!-- <div class="d-flex">
                    <div class="rectangle filled-target mt-3"></div>
                    <span class="ml-2 mt-2">: Proficiency Standard</span>
                    <div class="rectangle filled-achievement mt-3 ml-3"></div>
                    <span class="ml-2 mt-2">: Proficiency</span>
                  </div> -->
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_competency_experiential"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpExperiential"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <input type="text" class="form-control" v-model="searchExperiential" placeholder="Search..." />
                </div>
              </div>
              <!-- <div class="d-flex">
                <div class="rectangle filled-target mt-3"></div>
                <span class="ml-2 mt-2">: Proficiency Standard</span>
                <div class="rectangle filled-achievement mt-3 ml-3"></div>
                <span class="ml-2 mt-2">: Proficiency</span>
              </div> -->
              <div class="table overflow-scroll">
                <div v-if="isLoading" class="text-center my-4">
                  <span class="spinner-border" role="status" aria-hidden="true"></span>
                  <span>Loading...</span>
                </div>
                <table v-else class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <!-- Ini experiential -->
                    <!-- {{
                      experientialLearning
                    }} -->
                    <tr class="">
                      <!-- <th rowspan="2">Employee Name</th> -->
                      <th rowspan="2">Project Name</th>
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Start Date</th>
                      <th rowspan="2">End Date</th>
                      <th rowspan="2">Duration (Days)</th>
                      <th rowspan="2">Notes Manager</th>
                      <th class="text-center" rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <!-- v-if="
                      experientialLearning &&
                      experientialLearning.some(
                        (item) => item.coaching_title !== null
                      )
                    "> -->
                  <tbody v-if="experientialLearning && experientialLearning.length">
                    <tr v-for="(item, index) in experientialLearning" :key="index">
                      <!-- <td class="fw-bold">
                        <div class="">
                          {{ item.employee_name }}
                        </div>
                      </td> -->
                      <td class="">
                        <div class="">
                          {{ item.project.name }}
                        </div>
                      </td>
                      <td class="">
                        <ul class="list-unstyled mb-0">
                          <li v-for="(competency, cIndex) in item.competency" :key="cIndex">
                            {{ competency.name }}
                          </li>
                        </ul>
                        <!-- {{ item.competency }} -->
                      </td>
                      <td class="">
                        <div class="">
                          {{ formatDateTable(item.project.start_date) }}
                        </div>
                      </td>
                      <td class="">
                        <div class="">
                          {{ formatDateTable(item.project.end_date) }}
                        </div>
                      </td>
                      <td class="">
                        <div class="">
                          {{ item.project.duration }}
                        </div>
                      </td>
                      <td class="">
                        <div class="">
                          {{ item.notes || "-" }}
                        </div>
                      </td>
                      <td class="text-center">
                        <h2 v-if="item.status !== null">
                          <span :class="getBadgeStatus(item.status)">
                            <i :class="getIconClass(item.status)" class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </h2>
                        <span v-else></span>
                      </td>
                      <!-- <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mt-4"
                            v-for="(compe, rIndex) in item.competencies"
                            :key="rIndex">
                            {{ compe.competency }}
                          </li>
                        </ul>
                      </td> -->
                      <!-- <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            v-for="(compe, rIndex) in item.competencies"
                            :key="rIndex">
                            <div class="rectangle-container mt-4">
                              <div
                                v-for="n in 5"
                                :key="'proficiency_standard-' + n"
                                :class="[
                                  'rectangle',
                                  {
                                    'filled-target':
                                      n <= compe.proficiency_standard
                                  }
                                ]"></div>
                            </div>
                            <div class="rectangle-container mt-0">
                              <div
                                v-for="n in 5"
                                :key="'proficiency-' + n"
                                :class="[
                                  'rectangle',
                                  {
                                    'filled-achievement': n <= compe.proficiency
                                  }
                                ]"></div>
                            </div>
                          </li>
                        </ul>
                      </td> -->
                      <!-- <td>
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mt-4"
                            v-for="(compe, rIndex) in item.competencies"
                            :key="rIndex">
                            <span :class="getBadgeGap(compe.gap)">
                              {{ compe.gap > 0 ? "" + compe.gap : compe.gap }}
                            </span>
                          </li>
                        </ul>
                      </td> -->
                      <!-- <td v-if="item.competency !== null">
                        {{ item.competency_name }}
                      </td>
                      <td class="fw-bold" v-else></td> -->
                      <!-- <td class="">
                        <ul class="list-unstyled mb-0">
                          <li
                            class="mt-4"
                            v-for="(proj, rIndex) in item.experiential_learning"
                            :key="rIndex">
                            {{ proj.project_name }}
                          </li>
                        </ul>
                      </td> -->
                      <!-- <td class="text-center">
                        {{item.status}}
                          <span :class="getBadgeStatus(item.status)">
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </h2>
                        <span v-else></span>
                      </td> -->
                      <td class="text-center">
                        <!-- v-if="item.status === 'Completed'" -->
                        <!-- && item.status === 'completed' -->
                        <button
                          v-if="
                            listTabMenu &&
                            listTabMenu.tabMenu?.some(
                              (item) => item.title === 'Experiential Learning' && item.privilages.read
                            )
                          "
                          @click="viewActivities(item)"
                          class="btn btn-sm btn-info mx-2"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <button
                          v-if="item.status == 'submitted' && item.project.manager_nik == nikManagerByLogin"
                          @click="approvalProject(item)"
                          class="btn btn-sm btn-primary"
                          v-b-tooltip.hover="'Approval Menu'"
                        >
                          <span class="fe fe-user-check"></span>
                        </button>
                        <!-- <button
                          v-if="
                            item.status !== null &&
                            item.status === 'completed'
                          "
                          class="btn btn-sm btn-success mx-2"
                          @click="addScoreSocial(item)">
                          <span class="fe fe-award"></span>
                        </button> -->
                        <!-- <button
                          v-if="item.employee_name != null"
                          @click="assignProject(item)"
                          class="btn btn-sm btn-warning mx-2 mt-4">
                          <span class="fe fe-file-plus"></span>
                        </button>
                        <button
                          v-if="item.employee_name != null"
                          @click="viewProjectList(item)"
                          class="btn btn-sm btn-info mx-2 mt-4">
                          <span class="fe fe-message-circle"></span>
                        </button>
                        <button
                          v-if="item.status === 'Registered'"
                          class="btn btn-sm btn-primary mx-2">
                          <span class="fe fe-rotate-ccw"></span>
                        </button> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <p class="mt-3">
                  <i>
                    Note: If checked, it will be assigned. If unchecked, it will
                    not be assigned.
                  </i>
                </p> -->
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center my-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageExperiential"
                    :disabled="currentPageExperiential === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageExperiential }} of {{ totalPagesExperiential }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageStructure"
                    :disabled="currentPageExperiential === totalPagesExperiential || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageStructure"
                    @change="changePageSizeStructured(itemsPerPageStructure)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <!-- <div class="float-end mb-4">
                <b-button
                  v-if="
                    experientialLearning &&
                    experientialLearning.some((item) => item.coaching_title !== null)
                  "
                  @click="submitSocial()"
                  variant="primary">
                  <span class="fe fe-save"></span>
                  Approve
                </b-button>
                <b-button
                  v-else
                  @click="initStructuredLearning()"
                  variant="primary"
                  ><span class="fe fe-info"></span>
                  Get Recommendations
                </b-button>
              </div> -->
            </b-tab>
            <b-tab
              title="IDP Examination"
              v-if="
                listTabMenu && listTabMenu.tabMenu?.some((item) => item.title === 'IDP Examination' && item.privilages.read)
              "
            >
              <div class="card-body">
                <div class="col-lg-12 mt-5">
                  <div class="row mt-4">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>Name</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      <v-select
                        v-model="employee"
                        :options="listEmployee"
                        :reduce="(e) => e"
                        label="employee_name"
                        placeholder="Select Employee"
                        @input="selectEmployee"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>NIK</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      {{ nik || "-" }}
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>Position</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      {{ position || "-" }}
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="rectangle filled-danger mt-3"></div>
                  <span class="ml-2 mt-2">: Below Proficiency Standard</span>
                  <div class="rectangle filled-target mt-3 ml-3"></div>
                  <span class="ml-2 mt-2">: Meet Proficiency Standard</span>
                  <div class="rectangle filled-achievement mt-3 ml-3"></div>
                  <span class="ml-2 mt-2">: Above Proficiency Standard</span>
                  <b-button
                    v-if="this.nik"
                    v-b-modal.modal-loading
                    class="btn btn-primary ml-auto mt-5"
                    variant="primary"
                    title="Export IDP Report"
                    @click="exportPdf"
                  >
                    <span class="fe fe-download"></span>
                    IDP Report
                  </b-button>
                </div>
              </div>
              <b-tabs class="px-4">
                <b-tab title="All">
                  <div class="table overflow-scroll">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <!-- <th rowspan="2">Feedback</th> -->
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="paginatedItems.length > 0">
                        <tr v-for="(item, index) in paginatedItems" :key="index">
                          <td class="text-center">
                            {{ item.competency_name }}
                          </td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                            <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <!-- <td>
                            {{ item.feedback }}
                          </td> -->
                          <td class="text-center">
                            <!-- <button
                              v-if="item.items && item.items.length > 0"
                              @click="editProficiency(item)"
                              class="btn btn-sm btn-warning mx-2"
                              v-b-tooltip.hover="'Edit Proficiency'">
                              <span class="fe fe-edit"></span>
                            </button> -->
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="pagination-controls">
                      <label for="itemsPerPage">Items per page:</label>
                      <select id="itemsPerPage" v-model="itemsPerPage">
                        <option v-for="option in itemsPerPageOptions" :key="option" :value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                    <div class="pagination">
                      <button @click="prevPage" :disabled="currentPage === 1">Previous</button>
                      <span>Page {{ currentPage }} of {{ totalPages }}</span>
                      <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Structured Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <!-- <th rowspan="2">Feedback</th> -->
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.structured ? idpExamination.structured.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.structured" :key="index">
                          <td class="text-center">
                            {{ item.competency_name }}
                          </td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                            <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <!-- <td>
                            {{ item.feedback }}
                          </td> -->
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0"
                              @click="editProficiency(item)"
                              class="btn btn-sm btn-warning mx-2"
                              v-b-tooltip.hover="'Edit Proficiency'"
                            >
                              <span class="fe fe-edit"></span>
                            </button>
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
                <b-tab title="Social Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <!-- <th rowspan="2">Feedback</th> -->
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.social ? idpExamination.social.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.social" :key="index">
                          <td class="text-center">
                            {{ item.competency_name }}
                          </td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                            <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <!-- <td>
                            {{ item.feedback }}
                          </td> -->
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0"
                              @click="editProficiency(item)"
                              class="btn btn-sm btn-warning mx-2"
                              v-b-tooltip.hover="'Edit Proficiency'"
                            >
                              <span class="fe fe-edit"></span>
                            </button>
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
                <b-tab title="Experiential Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <!-- <th rowspan="2">Feedback</th> -->
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.experential ? idpExamination.experential.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.experential" :key="index">
                          <td class="text-center">
                            {{ item.competency_name }}
                          </td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                            <!-- {{ item.proficiency_new !== null ? item.proficiency_new : "-" }} -->
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <!-- <td>
                            {{ item.feedback }}
                          </td> -->
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0"
                              @click="editProficiency(item)"
                              class="btn btn-sm btn-warning mx-2"
                              v-b-tooltip.hover="'Edit Proficiency'"
                            >
                              <span class="fe fe-edit"></span>
                            </button>
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- MODAL HERE -->
    <b-modal id="modal-loading" size="sm" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
      <b class="d-flex justify-content-center mb-3">Please wait</b>
      <div class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading"></b-spinner>
      </div>
    </b-modal>
    <b-modal v-model="isEditProficiency" title="Update Proficiency" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Proficiency</label>
            <input v-model="bodyProficiency.proficiency" type="text" class="form-control" placeholder="Proficiency" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitEditProficiency()">Submit </b-button>
    </b-modal>
    <!-- Modal Edit Activities -->
    <b-modal v-model="isEditActivities" title="Edit Project Milestone" size="lg" hide-footer @hide="clearBodyActivities">
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Task</label>
            <input readonly v-model="bodyEditActivities.task" type="text" class="form-control" placeholder="Task" />
          </div>

          <div class="col-6 mt-4">
            <p class="form-label">Start Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.startDate"
            />
          </div>

          <div class="col-6 mt-4">
            <p class="form-label">End Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.endDate"
            />
          </div>
          <div class="col-12 mt-4">
            <label>Percentage (%)</label>
            <input
              readonly
              v-model="bodyEditActivities.percentage"
              type="number"
              class="form-control"
              placeholder="Percentage"
            />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Status</label>
            <v-select
              v-model="bodyEditActivities.status"
              :options="statusActivities"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Status"></v-select>
          </div> -->
          <div v-if="this.projectStatus != 'submitted'" class="col-12 mt-4">
            <p class="form-label">Actual Start Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.actualStartDate"
            />
          </div>
          <!-- <div class="col-2 mt-4">
            <b-button class="mt-4" @click="setActualStartDate" variant="primary"
              >Start</b-button
            >
          </div> -->
          <div v-if="this.projectStatus !== 'draft'" class="col-12 mt-4">
            <h4>
              Progress Data
              <!-- <b-button
                  v-if="this.progressPercentage != 100"
                  class="my-2 float-end"
                  @click="showAddProgress"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Progress</b-button
                > -->
            </h4>

            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Progress (%)</th>
                </tr>
              </thead>
              <tbody v-if="milestone.length != 0">
                <tr v-for="(item, index) in milestone" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ formatDateTable(item.date) }}</td>
                  <td>{{ item.progress }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="this.projectStatus != 'submitted'" class="col-12 mt-4">
            <label class="form-label">Progress</label>
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              v-model="progressPercentage"
              class="form-control-range mt-2"
              @mousedown.prevent
              @touchstart.prevent
            />
            <p class="mt-2">{{ progressPercentage }}%</p>
          </div>

          <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <p class="form-label">Actual End Date</p>
            <input
              readonly
              type="date"
              class="form-control"
              placeholder="Pilih Tanggal"
              v-model="bodyEditActivities.actualEndDate"
            />
          </div>
          <!-- <div v-if="progressPercentage == 100" class="col-2 mt-4">
            <b-button class="mt-4" @click="setActualEndDate" variant="primary"
              >Finish</b-button
            >
          </div> -->
          <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <label>Feedback</label>
            <textarea v-model="bodyFeedback.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
          <!-- <div v-if="progressPercentage == 100" class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
        <div
          v-if="
            this.projectStatus == 'in progress' && progressPercentage == 100
            // &&
            // selectedRow.manager_nik == nikManagerByLogin
          "
          class="mt-4"
        >
          <b-button class="float-end" @click="submitFeedback()" variant="primary">{{
            progressPercentage == 100 ? "Verified" : "Update"
          }}</b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Schedule -->
    <b-modal v-model="isScheduleModalVisible" title="Add Schedule" size="xl" hide-footer @hide="clearScheduleModal">
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <p class="form-label">Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.date"
              type="date"
              format="DD-MM-YYYY"
              placeholder="Select Date"
            />
          </div>
          <div class="col-6">
            <p class="form-label">Start Time</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.startTime"
              type="time"
              format="HH:mm"
              placeholder="Select Start Time"
            />
          </div>
          <div class="col-6 mt-4">
            <p class="form-label">End Time</p>
            <v-date-picker
              style="width: 350px"
              v-model="schedule.endTime"
              type="time"
              format="HH:mm"
              placeholder="Select End Time"
            />
          </div>
        </div>
        <div class="mt-4">
          <b-button class="float-end my-3" @click="addSchedule" variant="primary">Add</b-button>
        </div>
        <h4>The schedule will be added:</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th style="width: 50px">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="scheduleList.length === 0">
              <tr>
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button @click="removeSchedule(index)" class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="mt-4">
          <b-button class="float-end" @click="saveSchedule" variant="primary"><span class="fe fe-save"></span>Save</b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Add Training -->
    <b-modal
      v-model="isAddTraining"
      ref="modalTrainingAspiration"
      id="modal-training-aspiration"
      title="Buat Pelatihan Aspiration"
      hide-footer
      size="xl"
      centered
    >
      <div class="form-group">
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-6">
            <label class="form-label">Employee <span class="text-danger">(* Select Employee)</span></label>
            <v-select
              v-model="bodyAdd.nik"
              :options="dataEmployee"
              label="employee_name"
              :reduce="(e) => e.employee_nik"
              placeholder="Select Employee"
            />
          </div>
          <div class="col-6">
            <label class="form-label"
              >Competency <span class="text-danger">(* Proficiency level is below standard)</span></label
            >
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency"
              multiple
            />
          </div>
          <div class="mt-3">
            <hr />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider</label>
            <v-select
              v-model="bodyAdd.provider"
              :options="dataProvider"
              label="name"
              @input="selectProvider"
              :reduce="(e) => e.id"
              placeholder="Select Provider"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider Name</label>
            <input
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name"
              :disabled="bodyDisAdd.providerName"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address"
              :disabled="bodyDisAdd.address"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website"
              :disabled="bodyDisAdd.websiteProvider"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person"
              :disabled="bodyDisAdd.contactPerson"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email"
              :disabled="bodyDisAdd.email"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone"
              :disabled="bodyDisAdd.phone"
            />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Schedule</label>
          </div>
          <div class="col-6">
            <p class="form-label">Start Date</p>
            <v-date-picker style="width: 530px" />
          </div>
          <div class="col-6">
            <p class="form-label">End Date</p>
            <v-date-picker style="width: 530px" />
          </div> -->
        </div>
        <div class="mt-4">
          <hr />
        </div>
        <div class="row">
          <!-- Bagian 2 -->
          <div class="col-6 mt-3">
            <label for=""
              >Training
              <span class="text-danger">(* Search Training If Exist)</span>
            </label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              @search="searchTraining"
              placeholder="Search Training"
            >
              <!-- <span slot="no-options">Search Learning Title</span> -->
            </v-select>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Training Name</label>
            <input type="text" class="form-control" v-model="bodyAdd.trainingName" placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method"
            />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select style="width: 140px; color: gray" :options="currencies" v-model="bodyAdd.currency" class="mr-2" />
              <input v-model="bodyAdd.price" type="number" class="form-control" placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input type="text" class="form-control" v-model="bodyAdd.websiteTraining" placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Hours</label>
            <input v-model="bodyAdd.hours" type="number" class="form-control" placeholder="Input Hours" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Description</label>
            <textarea v-model="bodyAdd.description" type="text" class="form-control" placeholder="Input Description" />
          </div>
        </div>
        <div class="mt-3">
          <hr />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Explain the competencies of current employees or prospective participants<br />
            Jelaskan kompetensi karyawan atau calon peserta saat ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_1" placeholder="" />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Explain the expected competencies by attending this training<br />
            Jelaskan kompetensi yang diharapkan dengan mengikuti pelatihan ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_2" placeholder="" />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Describe the action plan for improving employee performance that will be carried out after attending this
            training<br />
            Uraikan rencana kegiatan untuk peningkatan kinerja karyawan yang akan dilakukan setelah mengikuti pelatihan ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_3" placeholder="" />
        </div>
        <div class="mt-4">
          <label class="form-label">Supporting Document</label>
          <input type="file" @change="handleFileChange" class="form-control" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
        </div>
        <div class="row">
          <div class="col-6 mt-3">
            <p>Start Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.startDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="Start Date"
            />
            <span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first("Start Date") }}</span>
          </div>
          <div class="col-6 mt-3">
            <p>End Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.startDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="Start Date"
            />
            <span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first("Start Date") }}</span>
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="createTraining()">Submit </b-button>
    </b-modal>
    <!-- Modal Score Structured -->
    <b-modal v-model="isModalScoreStructured" title="Add Score" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Score</label>
            <input v-model="bodyScoreStructured.score" type="text" class="form-control" placeholder="Score" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <input v-model="bodyScoreStructured.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitScoreStructured()">Submit </b-button>
    </b-modal>
    <!-- Modal Score Social -->
    <b-modal v-model="isModalScoreSocial" title="Add Score" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Score</label>
            <input v-model="bodyScoreSocial.score" type="text" class="form-control" placeholder="Score" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <input v-model="bodyScoreSocial.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitScoreSocial()">Submit </b-button>
    </b-modal>
    <b-modal v-model="isModalAssign" title="Assign Project" size="xl" hide-footer>
      <div v-if="isLoading" class="text-center my-4">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
        <span>Loading...</span>
      </div>
      <table v-else class="table table-sm table-bordered table-nowrap mt-4">
        <!-- {{
          projectData
        }} -->
        <thead>
          <tr class="">
            <th rowspan="2">Project Name</th>
            <th rowspan="2">Related Competencies</th>
            <th rowspan="2">Duration</th>
            <th rowspan="2">Start Date</th>
            <th rowspan="2">End Date</th>
            <th rowspan="2">Role</th>
            <th rowspan="2">Requirement</th>
            <th rowspan="2">Assignee</th>
            <th rowspan="2"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in projectData" :key="index">
            <td class="fw-bold">
              {{ item.project_name }}
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(competency, cIndex) in item.competencies" :key="cIndex">
                  {{ competency.competency }}
                </li>
              </ul>
            </td>
            <td class="">
              {{ item.project_duration }}
            </td>
            <td class="">
              {{ formatDateTable(item.project_start_date) }}
            </td>
            <td class="">
              {{ formatDateTable(item.project_end_date) }}
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  {{ role.project_role_name }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  {{ role.project_role_quantity }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  <ul class="pl-3">
                    <li v-for="(assignee, aIndex) in role.assignee" :key="aIndex">
                      {{ assignee.employee_name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
            <td class="">
              <ul class="list-unstyled mb-0">
                <li v-for="(role, rIndex) in item.roles" :key="rIndex">
                  <input
                    type="checkbox"
                    v-model="checkedRoles[item.project_id + '-' + role.project_role_name]"
                    :value="role.project_role_name"
                  />
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <b-button class="float-end" variant="primary" @click="submitAssignee()">Assign </b-button>
    </b-modal>
    <!-- Modal Activity -->
    <b-modal v-model="isModalActivities" title="Project Milestone" size="xl" hide-footer @hide="clearBodyActivities">
      <!-- {{selectedRow}} -->
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Project Name</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.name }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Project Description</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.description }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Duration</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.duration }} Days</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRow">
                <h2>
                  <span :class="getBadgeStatus(selectedRow.status)">
                    <i :class="getIconClass(selectedRow.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRow.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Start Date</b-card-title>
              <b-card-text v-if="selectedRow">{{ formatDateTable(selectedRow.project.start_date) }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>End Date</b-card-title>
              <b-card-text v-if="selectedRow">{{ formatDateTable(selectedRow.project.end_date) }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <!-- <b-col md="3" class="mt-4">
              <b-card-title>Involvement</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.involment
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Project Team</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.subordinate
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3" class="mt-4">
              <b-card-title>Bussiness Need</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.business_need || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Objectives</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.objectives || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Goals</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.goals || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Scope</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.scope || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Constraints</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.constraints || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Deliverables</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.deliverables || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact A</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.impact_a || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.impact || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4" class="mt-4">
              <b-card-title>Impact B</b-card-title>
              <b-card-text v-if="selectedRow">{{ selectedRow.project.impact_b || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="mt-4">
              <b-card-title>Project Teams</b-card-title>
              <b-card-text v-if="selectedRow">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Role</th>
                      <th>NIK</th>
                      <th>Name</th>
                      <th>Department</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in selectedRow?.teams" :key="index">
                      <td>{{ item.role }}</td>
                      <td>{{ item.nik }}</td>
                      <td>{{ item.employee_name }}</td>
                      <td>{{ item.department }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="selectedRow?.attachments">
              <b-card-title>Attachment</b-card-title>
              <img
                :src="selectedRow.attachments[0] ? selectedRow.attachments[0].url : ''"
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- <div class="mt-4 float-end mb-4">
        <b-button @click="addActivities" variant="primary"
          ><span class="fe fe-plus"></span>Add Activities</b-button
        >
      </div> -->

      <!-- Activities Table -->
      <div class="mt-4">
        <h4>Milestone</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <!-- <th>ID</th> -->
              <th>Task</th>
              <th>Start Date</th>
              <th>End Date</th>
              <!-- <th>Predecessor</th> -->
              <th>Actual Start Date</th>
              <th>Actual End Date</th>
              <th>Progress (%)</th>
              <!-- <th>Percentage (%)</th> -->
              <th>Status</th>
              <th>Evidence File</th>
              <th>Feedback</th>
              <th>Assignee</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="dataActivities.length != 0">
            <tr v-for="(item, index) in dataActivities" :key="index">
              <!-- <td>{{ item.iel_id }}</td> -->
              <td>{{ item.task }}</td>
              <td>{{ formatDateTable(item.start_date) }}</td>
              <td>{{ formatDateTable(item.end_date) }}</td>
              <!-- <td>{{ item.predecessor || "-" }}</td> -->
              <td>{{ formatDateTable(item.actual_start_date) || "-" }}</td>
              <td>{{ formatDateTable(item.actual_end_date) || "-" }}</td>
              <td>{{ item.new_progress || "-" }}</td>
              <!-- <td>{{ item.percentage || "-" }}</td> -->
              <td class="text-center">
                <h3>
                  <span :class="getBadgeStatus(item.status)">
                    <i :class="getIconClass(item.status)" class="me-1"></i>
                    {{ capitalizeStatus(item.status) }}
                  </span>
                </h3>
              </td>
              <td>
                <a v-if="item.evidence && item.evidence.length > 0" :href="item.evidence[0].url" target="_blank"> Files </a>
                <span v-else>-</span>
              </td>
              <td>
                <ul>
                  <li v-for="(feedback, fIndex) in item.feedback" :key="fIndex">
                    {{ feedback.feedback }}
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li v-for="(assignee, aIndex) in item.employee" :key="aIndex">
                    {{ assignee.employee_name }}
                  </li>
                </ul>
                <!-- <div>{{ formatTime(schedule.end_time) }}</div> -->
              </td>
              <td class="text-center">
                <!-- <button
                  v-if="item.status !== 'to do'"
                  class="btn btn-sm btn-info mx-1 my-1"
                  @click="addFeedback(item)"
                  v-b-tooltip.hover="'Add Feedback'">
                  <span class="fe fe-message-square"></span>
                </button> -->
                <button
                  v-if="item.status != 'completed'"
                  class="btn btn-sm btn-info mx-1 my-1"
                  @click="editActivities(item)"
                  v-b-tooltip.hover="'Detail'"
                >
                  <span class="fe fe-eye"></span>
                </button>
                <button
                  v-if="
                    (selectedRow.status == 'submitted' ||
                      selectedRow.status == 'draft' ||
                      selectedRow.status == 'revision') &&
                    item.nik?.includes(nikManagerByLogin)
                  "
                  class="btn btn-sm btn-danger mx-1 my-1"
                  @click="deleteActivities(item)"
                  v-b-tooltip.hover="'Delete'"
                >
                  <span class="fe fe-trash"></span>
                </button>
                <!-- <button
                  v-if="item.status === 'in review'"
                  class="btn btn-sm btn-success mx-1 my-1"
                  @click="completeActivities(item)"
                  v-b-tooltip.hover="'Complete Activities'">
                  <span class="fe fe-check-circle"></span>
                </button> -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="12">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!-- Modal Approval -->
    <b-modal v-model="isModalApproval" title="Approval Form" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label>Notes</label>
            <input v-model="bodyApproval.notes" type="text" class="form-control" placeholder="Notes" />
          </div>
          <div class="col-12 mt-4">
            <label>Approval Status</label>
            <b-form-group>
              <b-form-radio-group v-model="bodyApproval.status">
                <b-form-radio value="approved">Approved</b-form-radio>
                <b-form-radio value="revision">Need Revision</b-form-radio>
                <b-form-radio value="rejected">Rejected</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitApproval()">Submit </b-button>
    </b-modal>
    <!-- Feedback Social -->
    <b-modal v-model="isFeedbackSocial" title="Add Feedback" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Summary <span class="text-danger ml-2">*Read only</span></label>
            <textarea readonly v-model="bodyFeedback.summary" type="text" class="form-control" placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">Follow up <span class="text-danger ml-2">*Read only</span></p>
            <textarea readonly type="text" class="form-control" placeholder="Follow up" v-model="bodyFeedback.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <textarea v-model="bodyFeedback.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitFeedbackSocial()">Submit </b-button>
    </b-modal>
    <!-- Feedback Social Completed -->
    <b-modal v-model="feedbackCompleted" title="View Result" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Summary </label>
            <textarea readonly v-model="bodyFeedback.summary" type="text" class="form-control" placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">Follow up</p>
            <textarea readonly type="text" class="form-control" placeholder="Follow up" v-model="bodyFeedback.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <textarea readonly v-model="bodyFeedback.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
      </div>
      <!-- <b-button
        class="float-end"
        variant="primary"
        @click="submitFeedbackSocial()"
        >Submit
      </b-button> -->
    </b-modal>
    <!-- Modal Feedback Activities -->
    <b-modal v-model="isModalFeedbackActivities" title="Add Feedback" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label>Feedback</label>
            <input v-model="bodyFeedback.feedback" type="text" class="form-control" placeholder="Feedback" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="submitFeedback()">Submit </b-button>
    </b-modal>
    <!-- Modal View Feedback -->
    <b-modal v-model="isModalViewFeedback" title="Current Competency Proficiency after IDP" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <!-- Kompetensi -->
          <div class="row justify-content-center mb-4">
            <div class="col-12">
              <table class="table table-bordered text-center">
                <thead class="table-light">
                  <tr>
                    <th>Competency</th>
                    <th>Old Proficiency</th>
                    <th>Standart Proficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ bodyFeedbackExam.competency }}</td>
                    <td>{{ bodyFeedbackExam.old_proficiency }}</td>
                    <td>{{ bodyFeedbackExam.standartd_proficiency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Proficiency Saat Ini -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">New Proficiency</label>
            <input
              v-model="bodyFeedbackExam.proficiency"
              type="number"
              class="form-control"
              placeholder="Nilai Saat Ini"
              disabled
            />
          </div>

          <!-- Feedback (textarea) -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">Feedback</label>
            <textarea
              v-model="bodyFeedbackExam.feedback"
              class="form-control"
              rows="4"
              placeholder="Tulis feedback lebih lengkap..."
              disabled
            ></textarea>
          </div>
        </div>
      </div>
      <!-- <b-button class="float-end" variant="primary" @click="submitFeedback()"
        >Submit
      </b-button> -->
    </b-modal>
    <!-- Modal Project User -->
    <b-modal v-model="isModalFeedback" title="Project User" size="xl" hide-footer>
      <div v-if="isLoading" class="text-center my-4">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
        <span>Loading...</span>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-bordered table-nowrap mt-4">
          <thead>
            <tr class="">
              <th rowspan="2">Project ID</th>
              <th rowspan="2">Competency</th>
              <th rowspan="2">Project Name</th>
              <th rowspan="2">Project Type</th>
              <th rowspan="2">Start Date</th>
              <th rowspan="2">End Date</th>
              <th rowspan="2">Duration (Days)</th>
              <th rowspan="2">Status</th>
              <th rowspan="2">Action</th>
            </tr>
          </thead>
          <tbody v-if="projectUser.length > 0">
            <tr v-for="(item, index) in projectUser" :key="index">
              <td class="text-center">
                {{ item.project_id }}
              </td>
              <td class="">
                <ul class="list-unstyled mb-0">
                  <li v-for="(competency, cIndex) in item.competencies" :key="cIndex">
                    {{ competency.competency_name }}
                  </li>
                </ul>
              </td>
              <td class="text-center">
                {{ item.project_name }}
              </td>
              <td class="text-center">
                {{ item.project_type }}
              </td>
              <td class="text-center">
                {{ formatDateTable(item.project_start_date) || "-" }}
              </td>
              <td class="text-center">
                {{ formatDateTable(item.project_end_date) }}
              </td>
              <td class="text-center">
                {{ item.project_duration }}
              </td>
              <td class="text-center">
                <h2>
                  <span :class="getBadgeStatus(item.status)">
                    <i :class="getIconClass(item.status)" class="me-1"></i>
                    {{ capitalizeStatus(item.status) }}</span
                  >
                </h2>
              </td>

              <td class="text-center">
                <button @click="viewActivities(item)" v-if="item.status === 'submitted'" class="btn btn-sm btn-primary mx-2">
                  <span class="fe fe-file-text"></span>
                </button>
                <!-- <button
                          v-if="item.status === 'Execution'"
                          class="btn btn-sm btn-warning mx-2">
                          <span class="fe fe-edit"></span>
                        </button> -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="12">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <b-button class="float-end" variant="primary" @click="submitAssignee()"
        >Assign
      </b-button> -->
    </b-modal>

    <!-- Modal Detail Structured -->
    <b-modal v-model="isModalStructured" title="Detail View" size="xl" @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <!-- <b-col md="3">
              <b-card-title>Competency</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.competency
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3">
              <b-card-title>Training Title</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_title }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_type }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_method }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span :class="getBadgeStatus(selectedRowStructured.status)">
                    <i :class="getIconClass(selectedRowStructured.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Feedback</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.feedback || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Training Provider</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_provider }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Platform</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_platform }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Proposed By</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.proposed_by }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                {{ selectedRowStructured.training_currency }}
                {{ formatterNumber(selectedRowStructured.training_price) }}
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="6" class="mt-4">
              <b-card-title>Description</b-card-title>
              <textarea
                class="form-control form-control-flush form-control-auto"
                data-autosize
                rows="6"
                v-if="selectedRowStructured && selectedRowStructured.training_description != ''"
              >
                {{ selectedRowStructured.training_description || "-" }}
              </textarea>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Proficiency</b-card-title>
              <b-card-text v-if="selectedRowStructured?.com">
                <b-row v-for="com in selectedRowStructured.com" class="mb-3">
                  <span class="me-2">{{ com.competency }}</span>
                  <div class="button-container">
                    <div
                      v-for="num in 5"
                      :key="num"
                      class="button"
                      :class="{
                        active: selectedRowStructured?.proficiency === num,
                      }"
                    >
                      {{ num }}
                    </div>
                  </div>
                </b-row>
              </b-card-text>
            </b-col>
            <b-col md="3" class="mt-4" v-if="selectedRowStructured && selectedRowStructured?.proposed_time !== null">
              <b-card-title>Propossed Time</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                {{ selectedRowStructured?.proposed_time }}
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span
                    :class="
                      getBadgeStatus(selectedRowStructured.status)
                    ">
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row> -->
          <b-row md="4" class="mt-4" v-if="selectedRowStructured">
            <b-col v-if="selectedRowStructured.certificate">
              <b-card-title>Certificate</b-card-title>
              <img :src="certificateUrl" :style="{ width: '300px', height: 'auto' }" alt="Certificate" class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
          <!-- <b-button
            variant="primary"
            class="float-end"
            @click="completeReview(item)">
            <span class="fe fe-check-circle"></span> Complete
          </b-button> -->
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Detail Social -->
    <b-modal v-model="isModalSocial" title="Detail View" size="xl">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Coaching/Mentoring Title</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_title }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Category</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_type }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Coaching Methodology</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_methodology }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Coach Name</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coach_name }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowSocial">
                <h2>
                  <span :class="getBadgeStatus(selectedRowSocial.status)">
                    <i :class="getIconClass(selectedRowSocial.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowSocial.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>

            <b-col md="3">
              <b-card-title>Coaching/Mentoring Evidence</b-card-title>
              <b-link
                :href="selectedRowSocial.presentation_document_url ? selectedRowSocial.presentation_document_url : '#'"
                class="btn btn-danger"
                v-if="selectedRowSocial?.presentation_document_url"
                target="_blank"
                ><span class="fe fe-download"></span> Download</b-link
              >
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>

          <div class="mt-4">
            <div class="row">
              <div class="col">
                <h4>Schedule</h4>
              </div>
              <!-- <div class="col" v-if="selectedRowSocial">
                <b-button
                  v-if="selectedRowSocial.status == 'approved'"
                  class="float-end my-2"
                  @click="showScheduleModal"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Schedule</b-button
                >
              </div> -->
            </div>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th style="width: 110px">Date</th>
                  <th style="width: 50px">Start Time</th>
                  <th style="width: 50px">End Time</th>
                  <th>Summary</th>
                  <th>Feedback</th>
                  <th>Status</th>
                  <!-- <th>Follow Up</th> -->
                  <th style="width: 50px">Attachments</th>
                  <!-- <th>Feedback</th> -->
                  <th style="width: 50px">Action</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="scheduleSocial.length === 0">
                  <tr>
                    <td class="text-center" colspan="7">No Data Available</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item, index) in scheduleSocial" :key="index">
                    <td>{{ formatDateTable(item.date) }}</td>
                    <td>{{ formatTime(item.start_time) }}</td>
                    <td>{{ formatTime(item.end_time) }}</td>

                    <!-- Summaries -->
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'summary-' + feedbackIndex">
                          {{ feedback.summary }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No summaries available</li>
                        </template>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'summary-' + feedbackIndex">
                          {{ feedback.feedback }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No summaries available</li>
                        </template>
                      </ul>
                    </td>
                    <td>
                      <span :class="getBadgeStatus(item.status)">
                        <i :class="getIconClass(item.status)" class="me-1"></i>
                        {{ capitalizeStatus(item.status) }}</span
                      >
                    </td>

                    <!-- Follow Ups -->
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.follow_up }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No follow-ups available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Attachments -->
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'attachment-' + feedbackIndex">
                          <a
                            v-for="(attachment, attachmentIndex) in feedback.attachments"
                            :key="'attachment-file-' + attachmentIndex"
                            :href="attachment.url"
                            target="_blank"
                          >
                            Files
                          </a>
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No attachments available</li>
                        </template>
                      </ul>
                    </td>
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.feedback }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No Feedback available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Action Button -->
                    <td>
                      <button
                        v-if="
                          (selectedRowSocial.status === 'approved' || selectedRowSocial.status === 'in progress') &&
                          item.feedback.length > 0
                        "
                        class="btn btn-sm btn-warning"
                        @click="showModalFeedback(item)"
                        v-b-tooltip.hover="'Input Coaching Result'"
                      >
                        <span class="fe fe-edit"></span>
                      </button>
                      <button
                        v-if="selectedRowSocial.status === 'completed' && item.feedback.length > 0"
                        class="btn btn-sm btn-info my-2"
                        @click="completedFeedback(item)"
                        v-b-tooltip.hover="'View Coaching Result'"
                      >
                        <span class="fe fe-eye"></span>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div v-if="selectedRowSocial">
            <b-button
              v-if="selectedRowSocial.status == 'in review'"
              class="float-end my-2"
              @click="completeLearning"
              variant="primary"
              >Complete</b-button
            >
          </div>
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Confirmation -->
    <b-modal
      centered
      ref="confirmationModalStructured"
      id="confirmation-modal"
      title="Approve Training"
      @ok="confirmSubmissionStructured"
    >
      <div>
        <h5>Will be Approved:</h5>
        <ul v-if="checkSTructuredLearning && checkSTructuredLearning.length > 0">
          <li v-for="item in checkSTructuredLearning" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <h5>Note : Other trainings except the abovementioned data will be automatically rejected</h5>
        <!-- <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li
            v-for="item in rejectedItems"
            :key="item.id"
            class="text-danger"
            v-if="item.status === 'submitted' && item.id">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p> -->
      </div>
    </b-modal>

    <!-- Modal Confirmation Social -->
    <b-modal
      centered
      ref="confirmationModalSocial"
      id="confirmation-modal"
      title="Approve Coaching/Mentoring"
      @ok="confirmSubmissionSocial"
    >
      <div>
        <h5>Will be Approved:</h5>
        <ul v-if="checkSocialLearning && checkSocialLearning.length > 0">
          <li v-for="item in checkSocialLearning" :key="item.id" class="text-success">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <h5>Note : Other coachings except the abovementioned data will be automatically rejected</h5>
        <!-- <ul v-if="rejectedItemsSocial && rejectedItemsSocial.length > 0">
          <li
            v-for="item in rejectedItemsSocial"
            :key="item.id"
            class="text-danger"
            v-if="item.status === 'submitted' && item.id">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p> -->
      </div>
    </b-modal>
    <!-- Report Modal -->
    <ReportModal v-model:visible="isShowReport" :listIdpPeriod="listIdpPeriod" :role="roleLogin" @export="handleExport" />
  </div>
</template>

<script>
import axiosIns from "@/api/axios";

import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import ReportModal from "@/components/ReportModal.vue";
import { EXPORT_COMMON_REPORT, getReportFilename } from "@/api/common/reports";

export default {
  name: "myTeamIdp",
  components: {
    ReportModal,
  },
  data() {
    return {
      isAddTraining: false,
      coaches: [],
      searchStructure: "",
      filter_competency_struckture: "",
      filter_type_struckture: "",
      filter_platform_struckture: "",
      currentPageStructure: 1,
      itemsPerPageStructure: 10,
      totalPagesStructure: 1,
      searchSocial: "",
      filter_competency_social: "",
      filter_type_social: "",
      currentPageSocial: 1,
      itemsPerPageSocial: 10,
      totalPagesSocial: 1,
      searchExperiential: "",
      filter_competency_experiential: "",
      currentPageExperiential: 1,
      itemsPerPageExperiential: 10,
      totalPagesExperiential: 1,
      dataEmployee: [],
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 50],
      listTabMenu: [],
      nik: "",
      nikManager: "",
      roleLogin: localStorage.getItem("roles"),
      nikManagerByLogin: localStorage.getItem("nik"),
      name: "",
      position: "",
      idpExamination: [],
      employee: "",
      listEmployee: [],
      employeeStructuredLearning: "",
      nikStructuredLearning: "",
      positionStructuredLearning: "",
      ListEmployeeStructuredLearning: [],
      employeeSocial: "",
      nikSocial: "",
      positionSocial: "",
      ListEmployeeSocial: [],
      employeeExperiential: "",
      nikExperiential: "",
      positionExperiential: "",
      ListEmployeeExperiential: [],
      isEditProficiency: false,
      bodyProficiency: {
        id: "",
        proficiency: "",
      },
      sRowStructured: [],
      sRowSocial: [],
      projectStatus: "",
      milestone: [],
      scheduleList: [],
      schedule: {
        date: null,
        startTime: null,
        endTime: null,
      },
      feedbackCompleted: false,
      isFeedbackSocial: false,
      isScheduleModalVisible: false,
      idIdpSocial: "",
      scheduleSocial: [],
      statusActivities: [
        { id: "to do", name: "To Do" },
        { id: "in progress", name: "In Progress" },
        { id: "completed", name: "Completed" },
      ],
      bodyEditActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: "",
      },
      progressPercentage: "",
      certificateUrl: "",
      certificateName: "",
      dataActivities: [],
      bodyActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: "",
        assignee: "",
      },
      bodyEditActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: "",
        nik: [],
      },
      projectUser: [],
      selectedLearning: null,
      projectData: [],
      checkedRoles: {},
      ListDataEmployee: [],
      certificateName: "",
      bodyScoreStructured: {
        id: "",
        score: "",
        feedback: "",
      },
      bodyScoreSocial: {
        id: "",
        score: "",
        feedback: "",
      },
      bodyFeedback: {
        id: "",
        nik: "",
        summary: "",
        follow_up: "",
        feedback: "",
        viewFeedback: "",
      },
      bodyFeedbackExam: {
        competency: "",
        old_proficiency: "",
        standartd_proficiency: "",
        proficiency: "",
        feedback: "",
      },
      bodyApproval: {
        id: "",
        notes: "",
        status: "",
      },
      bodyAdd: {
        nik: "",
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: "",
        websiteTraining: "",
        description: "",
        hours: "",
        background_1: "",
        background_2: "",
        background_3: "",
        startDate: "",
        endDate: "",
      },
      bodyDisAdd: {
        providerName: false,
        address: false,
        websiteProvider: false,
        contactPerson: false,
        email: false,
        phone: false,
      },
      bodyAssign: {
        nik: "",
      },
      listIdpPeriod: [],
      isShowReport: false,
      isModalStructured: false,
      isModalSocial: false,
      isModalScoreStructured: false,
      isModalScoreSocial: false,
      isModalAssign: false,
      isModalFeedback: false,
      isModalFeedbackActivities: false,
      isModalViewFeedback: false,
      isModalActivities: false,
      isModalApproval: false,
      isEditActivities: false,
      checkStructured: false,
      checkSocial: false,
      dataCompetency: [],
      dataProvider: [],
      dataTrainingMethod: [],
      dataTrainingType: [],
      dataTraining: [],
      structuredLearning: [],
      listStructuredLearning: [],
      socialLearning: [],
      experientialLearning: [],
      selectedRowStructured: null,
      selectedRowSocial: null,
      selectedRow: null,
      srStructuredLearning: [],
      srSocialLearning: [],
      srExperientialLearning: [],
      checkSTructuredLearning: [],
      checkSocialLearning: [],
      approvedItems: [],
      rejectedItems: [],
      approvedItemsSocial: [],
      rejectedItemsSocial: [],
      currencies: ["USD", "IDR"],
      selectedCurrency: "IDR",
      isLoading: true,
      isLoadingBulkApprove: false,
      isEmpty: false,
      currentTab: 0,
      tabTitles: ["Progress Summary", "Structured Learning", "Social Learning", "Experiential Learning"],
      summary: [
        {
          no: "A",
          isBold: true,
          isBab: true,
          isSub: false,
          isBehaviour: false,
          competency: "Managerial Competency",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null,
        },
        {
          no: 1,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Personal Effectiveness",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null,
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Continuous Learning",
          structureLearning: "100%",
          socialLearning: "100%",
          experientialLearning: "100%",
          status: "Completed",
        },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 1",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 2",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        {
          no: "B",
          isBold: true,
          isBab: true,
          isSub: false,
          isBehaviour: false,
          competency: "Technical Competency",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null,
        },
        {
          no: 1,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "General Technical Management Competencies",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null,
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Risk Management",
          structureLearning: "100%",
          socialLearning: "100%",
          experientialLearning: "100%",
          status: "Completed",
        },
        // {
        //   no: null,
        //   isBold: true,
        //   isBab: false,
        //   isSub: true,
        //   isBehaviour: true,
        //   competency: "Key Behaviour 1",
        //   structureLearning: "100%",
        //   socialLearning: "100%",
        //   experientialLearning: "100%",
        //   status: "Completed"
        // },
        {
          no: 2,
          isBold: true,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Core Technical Competencies",
          structureLearning: null,
          socialLearning: null,
          experientialLearning: null,
          status: null,
        },
        {
          no: null,
          isBold: false,
          isBab: false,
          isSub: true,
          isBehaviour: false,
          competency: "Bussiness Savvy",
          structureLearning: "0%",
          socialLearning: "0%",
          experientialLearning: "0%",
          status: "In Progress",
        },
      ],
    };
  },
  computed: {
    filteredDataStructure() {
      if (!this.searchStructure || this.searchStructure.trim() === "") {
        return this.structuredLearning;
      }

      const query = this.searchStructure.toLowerCase();
      return this.structuredLearning.filter((item) => {
        return item.training_title && item.training_title.toLowerCase().includes(query);
      });
    },
    totalPagesStruckture() {
      return Math.ceil(this.filteredDataStructure.length / this.itemsPerPageStructure);
    },
    // Paginated data to display
    paginatedDataStruckture() {
      const start = (this.currentPageStructure - 1) * this.itemsPerPageStructure;
      const end = start + this.itemsPerPageStructure;
      return this.filteredDataStructure.slice(start, end);
    },
    filteredDataSocial() {
      if (!this.searchSocial || this.searchSocial.trim() === "") {
        return this.socialLearning;
      }

      const query = this.searchSocial.toLowerCase();
      return this.socialLearning.filter((item) => {
        return item.coaching_title && item.coaching_title.toLowerCase().includes(query);
      });
    },
    // totalPagesSocial() {
    //   return Math.ceil(
    //     this.filteredDataSocial.length / this.itemsPerPageSocial
    //   );
    // },
    // Paginated data to display
    paginatedDataSocial() {
      const start = (this.currentPageSocial - 1) * this.itemsPerPageSocial;
      const end = start + this.itemsPerPageSocial;
      return this.filteredDataSocial.slice(start, end);
    },
    canCreateStructuredLearning() {
      return this.listTabMenu?.tabMenu?.some((item) => item.title === "Structured Learning" && item.privilages.create);
    },
    totalPages() {
      return this.idpExamination && this.idpExamination.all
        ? Math.ceil(this.idpExamination.all.length / this.itemsPerPage)
        : 0;
    },
    paginatedItems() {
      if (this.idpExamination && this.idpExamination.all) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.idpExamination.all.slice(start, end);
      }
      return [];
    },
    aboutMe() {
      return this.$store.getters["users/profiles"];
    },
    flattenedProjectData() {
      let flattened = [];

      this.projectData.forEach((project) => {
        project.roles.forEach((role) => {
          flattened.push({
            project_name: project.project_name,
            competencies: project.competencies,
            project_duration: project.project_duration,
            project_start_date: project.project_start_date,
            project_end_date: project.project_end_date,
            role_name: role.project_role_name,
            role_quantity: role.project_role_quantity,
            assignees: role.assignee,
            project_id: project.project_id,
            role_id: role.project_role_id,
          });
        });
      });

      return flattened;
    },
    allRoles() {
      let roles = [];
      this.projectData.forEach((project) => {
        project.roles.forEach((role) => {
          if (!roles.includes(role.project_role_name)) {
            roles.push(role.project_role_name);
          }
        });
      });
      return roles;
    },
    activeTabTitle() {
      return this.tabTitles[this.currentTab];
    },
    // aboutMe() {
    //   return this.$store.getters["users/profiles"];
    // },
    personalData() {
      let datas = this.$store.getters["dashboard/personalDashboard"];
      return datas;
    },
  },
  watch: {
    searchStructure: {
      handler: "onSearchStructure",
      immediate: false,
    },
    searchSocial: {
      handler: "onSearchSocial",
      immediate: false,
    },
    searchExperiential: {
      handler: "onSearchExperiential",
      immediate: false,
    },

    // aboutMe() {
    //   this.getEmployee();
    // },
    selectedLearning(newVal) {
      if (newVal) {
        this.bodyAdd.training = newVal.id;
      } else {
        this.bodyAdd.training = null;
      }
    },
    "bodyAdd.provider": "fetchTrainingData",
    "bodyAdd.competency": "fetchProviderByCompetency",
  },
  methods: {
    showAddTraining() {
      this.isAddTraining = true;
      this.fetchTrainingData();
      this.fetchProviderByCompetency();
    },
    getAllEmployees() {
      this.$store.dispatch("employee/getEmployees").then((res) => {
        this.listEmployee = res.data;
        this.dataEmployee = res.data;
        this.ListEmployeeStructuredLearning = res.data;
        this.ListEmployeeSocial = res.data;
        this.ListEmployeeExperiential = res.data;
      });
    },
    onSearchStructure() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.getDataIdpStructured(1, this.searchStructure);
      }, 500);
    },
    onSearchSocial() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.getDataIdpSocial(1, this.searchSocial);
      }, 500);
    },
    onSearchExperiential() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.getDataIdpExperiential(1, this.searchExperiential);
      }, 500);
    },

    changePageSizeStructured(newSize) {
      this.itemsPerPageStructure = newSize;
      this.getDataIdpStructured(1, this.searchStructure);
    },
    changePageSizeSocial(newSize) {
      this.itemsPerPageSocial = newSize;
      this.getDataIdpSocial(1, this.searchSocial);
    },
    changePageSizeSocial(newSize) {
      this.itemsPerPageExperiential = newSize;
      this.getDataIdpExperiential(1, this.searchExperiential);
    },
    getDataIdpStructured() {
      this.isLoading = true;
      const params = {
        nik: this.nikStructuredLearning,
        pageNumber: this.currentPageStructure,
        pageSize: this.itemsPerPageStructure || 10,
        search: this.searchStructure,
        filter_competency: this.filter_competency_struckture?.competency_id || "",
        filter_type: this.filter_type_struckture,
        filter_platform: this.filter_platform_struckture,
      };

      this.$store
        .dispatch("myIdp/getMyStructured", params)
        .then((res) => {
          const strukturData = res.data.data || [];

          this.structuredLearning = strukturData.flatMap((item) => {
            if (!item.competency || item.competency.length === 0) {
              return [
                {
                  competency: null,
                  proficiency: null,
                  proficiency_standard: null,
                  difference: 0,
                  id: item.id,
                  idp_id: item.idp_id,
                  competency_id: item.competency_id,
                  training_id: item.training_id,
                  certificate: item.certificate,
                  score: item.score,
                  proposed_by: item.proposed_by,
                  status: item.status,
                  isAllowedAction: item.isAllowedAction,
                  feedback: item.feedback,
                  training_title: item.training_title,
                  training_description: item.training_description,
                  training_hours: item.training_hours,
                  training_url: item.training_url,
                  training_type: item.training_type,
                  training_provider: item.training_provider,
                  training_platform: item.training_platform,
                  training_currency: item.training_currency,
                  training_price: item.training_price,
                  training_method: item.training_method,
                  proposed_time: item.proposed_time,
                },
              ];
            }

            return item.competency.map((comp, index) => ({
              com: item.competency,
              competency: comp.competency,
              proficiency: comp.proficiency,
              proficiency_standard: comp.proficiency_standard,
              difference: comp.proficiency - comp.proficiency_standard,
              id: index === 0 ? item.id : null,
              idp_id: index === 0 ? item.idp_id : null,
              competency_id: index === 0 ? item.competency_id : null,
              training_id: index === 0 ? item.training_id : null,
              certificate: index === 0 ? item.certificate : null,
              score: index === 0 ? item.score : null,
              proposed_by: index === 0 ? item.proposed_by : null,
              status: item.status,
              isAllowedAction: item.isAllowedAction,
              feedback: index === 0 ? item.feedback : null,
              training_title: index === 0 ? item.training_title : null,
              training_description: index === 0 ? item.training_description : null,
              training_hours: index === 0 ? item.training_hours : null,
              training_url: index === 0 ? item.training_url : null,
              training_type: index === 0 ? item.training_type : null,
              training_provider: index === 0 ? item.training_provider : null,
              training_platform: index === 0 ? item.training_platform : null,
              training_currency: index === 0 ? item.training_currency : null,
              training_price: index === 0 ? item.training_price : null,
              training_method: index === 0 ? item.training_method : null,
              proposed_time: index === 0 ? item.proposed_time : null,
            }));
          });

          this.currentPageStructure = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageStructure = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesStructure = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsStructure = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.structuredLearning || this.structuredLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
          this.structuredLearning = [];
          this.currentPageStructure = 1;
          this.totalPagesStructure = 1;
          this.totalItemsStructure = 0;
        });
    },
    getDataIdpSocial(page = 1, search = "") {
      this.isLoading = true;
      const params = {
        nik: this.nikSocial,
        pageNumber: this.currentPageSocial,
        pageSize: this.itemsPerPageSocial || 10,
        search: this.searchSocial,
        filter_competency: this.filter_competency_social?.competency_id || "",
        filter_type: this.filter_type_social,
      };
      this.$store
        .dispatch("myIdp/getMySocial", params)
        .then((res) => {
          const socialData = res.data.data || [];
          // this.sol_rekom = res.data[0].sol_recomend;
          this.socialLearning = socialData.flatMap((item) => {
            return item.competency.map((comp, index) => {
              const gap =
                comp.proficiency > comp.proficiency_standard
                  ? comp.proficiency - comp.proficiency_standard
                  : comp.proficiency < comp.proficiency_standard
                  ? -(comp.proficiency_standard - comp.proficiency)
                  : 0;
              return {
                competency: comp.competency,
                proficiency: comp.proficiency,
                proficiency_standard: comp.proficiency_standard,
                difference: gap,
                id: index === 0 ? item.id : null,
                idp_id: index === 0 ? item.idp_id : null,
                coaching_id: index === 0 ? item.coaching_id : null,
                coaching_title: index === 0 ? item.coaching_title : null,
                coaching_methodology: index === 0 ? item.coaching_methodology : null,
                is_completed: index === 0 ? item.is_completed : null,
                coach_name: index === 0 ? item.coach_name : null,
                coaching_hour: index === 0 ? item.coaching_hour : null,
                status: item.status,
                presentation_document_url: item.presentation_document_url,
                coaching_type: item.coach_type,
              };
            });
          });
          this.currentPageSocial = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageSocial = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesSocial = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsSocial = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.socialLearning || this.socialLearning.length === 0;
          this.isLoading = false;
          this.preselectRows();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    getDataIdpExperiential(page = 1, search = "") {
      this.isLoading = true;
      const params = {
        nik: this.nikExperiential,
        pageNumber: this.currentPageExperiential,
        pageSize: this.itemsPerPageExperiential || 10,
        search: this.searchExperiential,
        filter_competency: this.filter_competency_experiential?.competency_id || "",
      };

      this.$store
        .dispatch("myIdp/getMyExperiential", params)
        .then((res) => {
          const experientialData = res.data.data || [];

          this.experientialLearning = experientialData.map((item) => ({
            id: item.id,
            idp_id: item.idp_id,
            notes: item.notes,
            project_id: item.project_id,
            status: item.status,
            project: item.project,
            competency: item.competency,
            teams: item.teams,
            creator: item.creator,
          }));
          this.currentPageExperiential = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageExperiential = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesExperiential = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsExperiential = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.experientialLearning || this.experientialLearning.length === 0;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    dimensionChart() {
      // let width = [800, 1024, 1366, 1600, 1920]
      if (window.innerWidth <= 800) {
        return "500";
      } else if (window.innerWidth <= 1024) {
        return "400";
      } else if (window.innerWidth <= 1366) {
        return "280";
      } else if (window.innerWidth <= 1600) {
        return "300";
      } else if (window.innerWidth < 1920) {
        return "400";
      }
    },
    chartOption(e) {
      let col = ["#F44336", "#00d97e", "#39afd1", "#00d97e"];
      // let chart = ""
      if (window.innerWidth <= 800) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1024) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1366) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1600) {
        this.chartSize = 250;
      } else if (window.innerWidth < 1920) {
        this.chartSize = 250;
      }

      let bodys = {
        chart: {
          height: this.chartSize,
          type: "radialBar",
          offsetY: -20,
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: "97%",
              margin: 3, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -1,
                fontSize: "32px",
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: "fill",
          colors: col[e],
          gradient: {
            shade: "light",
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91],
          },
        },
        labels: ["Average Results"],
      };

      return bodys;
    },
    totals(e) {
      return [e];
    },
    changeOnceCheckboxStructured(item) {
      const position = this.checkSTructuredLearning.findIndex((data) => data.id === item.id);
      if (position === -1) {
        this.checkSTructuredLearning.push({
          id: item.id,
          training_title: item.training_title,
        });
      } else {
        this.checkSTructuredLearning.splice(position, 1);
      }
    },
    changeOnceCheckboxSocial(item) {
      const position = this.checkSocialLearning.findIndex((data) => data.id === item.id);
      if (position === -1) {
        this.checkSocialLearning.push({
          id: item.id,
          coaching_title: item.coaching_title,
        });
      } else {
        this.checkSocialLearning.splice(position, 1);
      }
    },
    changeAllStructur() {
      this.checkStructured = !this.checkStructured;
      this.$nextTick(() => {
        console.log("Checkbox state:", this.checkStructured);
        if (this.checkStructured) {
          this.sRowStructured = this.structuredLearning.map((item) => item.id);
        } else {
          this.sRowStructured = [];
        }
      });
    },
    changeAllSocial() {
      this.checkSocial = !this.checkSocial;
      this.$nextTick(() => {
        console.log("Checkbox state:", this.checkSocial);
        if (this.checkSocial) {
          this.sRowSocial = this.socialLearning
            .filter((item) => item.status === "draft" || item.status === "submitted")
            .map((item) => item.id);
        } else {
          this.sRowSocial = [];
        }
      });
    },
    bulkApproved() {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Apakah Anda yakin menyetujui data yang berstatus review? ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingBulkApprove = true;
          const allInReviewSocialLearnings = this.ListDataEmployee.flatMap((employee) =>
            employee.social_learning.filter((learning) => learning.status === "in review")
          );
          let datas = {
            id: allInReviewSocialLearnings.map((item) => item.id),
          };

          if (datas.id.length === 0) {
            this.$swal("Error", "Tidak ada data untuk disetujui", "error");
          } else {
            this.$store
              .dispatch("myIdp/bulkApprovedSocial", datas)
              .then((response) => {
                this.$swal("Selesai", "Persetujuan berhasil", "success");
                let dataSocial = {
                  nik: this.nikSocial,
                  employee_position: this.positionSocial,
                };
                let dataStructured = {
                  nik: this.nikStructuredLearning,
                  employee_position: this.positionStructuredLearning,
                };
                let dataExperiental = {
                  nik: this.nikExperiential,
                  employee_position: this.positionExperiential,
                };
                this.$store.dispatch("myIdp/getIdpManager").then((res) => {
                  const dataArray = res.data;
                  this.ListDataEmployee = dataArray;
                  setTimeout(() => {
                    this.selectEmployeeSocial(dataSocial);
                    this.selectEmployeestructuredLearning(dataStructured);
                    this.selectEmployeeExperiential(dataExperiental);
                    this.refreshApproveEmployeestructuredLearning();
                    this.refreshEmployeeSocial();
                    this.isLoadingBulkApprove = false;
                  }, 1050);
                });
              })
              .catch((error) => {
                this.$swal("Error", error.response.error, "error");
                console.error("Review failed:", error);
              });
          }
        }
      });
    },
    exportPdf() {
      this.$bvModal.show("modal-loading");
      axiosIns
        .get(`${axiosIns.defaults.baseURL}/idp-report?nik=${this.nik}`, {
          responseType: "blob",
        })
        .then((resp) => {
          // console.log(resp);
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `IDP-Report-${this.name}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$bvModal.hide("modal-loading");
        })
        .catch((resp) => {
          this.$swal("Error", `${resp.response.data.error}`, "error");
          this.$bvModal.hide("modal-loading");
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    editProficiency(item) {
      this.isEditProficiency = true;
      this.bodyProficiency = {
        id: item.id,
        proficiency: item.proficiency,
      };
    },
    submitEditProficiency() {
      let request = {
        id: this.bodyProficiency.id,
        data: {
          proficiency: Number(this.bodyProficiency.proficiency),
        },
      };
      this.$store
        .dispatch("idpExamination/editProficiencyIdp", request)
        .then((response) => {
          this.$swal("Success", "Proficiency berhasil diubah", "success");
          this.isEditProficiency = false;
          this.getIdpExamination();
        })
        .catch((error) => {
          this.$swal("Error", "Gagal mengubah proficiency: " + (error.response?.data?.message || error.message), "error");
        });
    },
    getEmployee() {
      if (this.nikManagerByLogin) {
        this.$store.dispatch("idpExamination/getEmployeeByManager", this.nikManagerByLogin).then((res) => {
          this.listEmployee = res.data;
          this.dataEmployee = res.data;
          this.ListEmployeeStructuredLearning = res.data;
          this.ListEmployeeSocial = res.data;
          this.ListEmployeeExperiential = res.data;
        });
      }
    },
    getIdpExamination() {
      this.$store.dispatch("idpExamination/getIdpExaminationByNik", this.nik).then((res) => {
        this.idpExamination = res.data;
      });
    },
    getPersonalData(nik) {
      this.$store.dispatch("dashboard/getDashboardPersonalData", { nik });
    },
    selectEmployee(e) {
      this.getPersonalData(e.nik);
      this.nik = e.nik;
      this.name = e.employee_name;

      this.$store.dispatch("idpExamination/getIdpExaminationByNik", e.nik).then((res) => {
        const groupedData = res.data.reduce(
          (acc, item) => {
            // Tambahkan kompetensi ke kategori "all"
            if (!acc.all) acc.all = [];
            let allCompetency = acc.all.find((c) => c.id === item.id);
            if (!allCompetency) {
              allCompetency = { ...item, items: [...item.items] };
              acc.all.push(allCompetency);
            }

            // Pisahkan berdasarkan idp_type
            item.items.forEach((learning) => {
              const type = learning.idp_type || "unknown";

              if (!acc[type]) {
                acc[type] = [];
              }

              let existingCompetency = acc[type].find((c) => c.id === item.id);
              if (!existingCompetency) {
                existingCompetency = { ...item, items: [] };
                acc[type].push(existingCompetency);
              }

              existingCompetency.items.push(learning);
            });

            return acc;
          },
          { structured: [], social: [], experential: [], all: [] }
        );
        // console.log("grouped data=>",groupedData)
        this.idpExamination = groupedData;
      });
    },

    selectEmployeestructuredLearning(e) {
      this.getPersonalData(e.nik);
      this.nikStructuredLearning = e.nik || e.employee_nik;
      this.getDataIdpStructured();
      this.getCompetency(this.nikStructuredLearning);
      this.positionStructuredLearning = e.employee_position;
      this.checkSTructuredLearning = [];
      this.sRowStructured = [];
      const dataArray = this.ListDataEmployee.filter((item) => item.nik == e.nik);
      this.dataEmployee = dataArray.map((employee) => ({
        employee_name: employee.employee_name,
        employee_nik: employee.employee_nik,
      }));

      const structureLearningMap = new Map();
      let previousEmployeeName = null;
      dataArray.forEach((data) => {
        const employeeName = data.employee_name;
        if (!structureLearningMap.has(employeeName)) {
          structureLearningMap.set(employeeName, []);
        }

        data.structured_learning.forEach((exp) => {
          exp.competency.forEach((comp, index) => {
            const gap =
              comp.proficiency > comp.proficiency_standard
                ? comp.proficiency - comp.proficiency_standard
                : comp.proficiency < comp.proficiency_standard
                ? -(comp.proficiency_standard - comp.proficiency)
                : 0;

            const employeeNameToDisplay = previousEmployeeName !== employeeName ? employeeName : null;

            structureLearningMap.get(employeeName).push({
              competency: comp.competency,
              proficiency: comp.proficiency,
              proficiency_standard: comp.proficiency_standard,
              difference: comp.difference || null,
              gap: gap,
              id: index === 0 ? exp.id : null,
              idp_id: index === 0 ? exp.idp_id : null,
              training_id: index === 0 ? exp.training_id : null,
              certificate: index === 0 ? exp.certificate : null,
              score: index === 0 ? exp.score : null,
              status: exp.status,
              proposed_by: index === 0 ? exp.proposed_by : null,
              feedback: index === 0 ? exp.feedback : null,
              training_title: index === 0 ? exp.training_title : null,
              training_hours: index === 0 ? exp.training_hours : null,
              training_description: index === 0 ? exp.training_description : null,
              training_type: index === 0 ? exp.training_type : null,
              training_provider: index === 0 ? exp.training_provider : null,
              training_platform: index === 0 ? exp.training_platform : null,
              training_currency: index === 0 ? exp.training_currency : null,
              price: index === 0 ? exp.training_price : null,
              training_method: index === 0 ? exp.training_method : null,
              proposed_time: index === 0 ? exp.proposed_time : null,
              employee_name: employeeNameToDisplay,
            });

            if (employeeNameToDisplay) {
              previousEmployeeName = employeeName;
            }
          });
        });
      });
      this.structuredLearning = Array.from(structureLearningMap.values()).flat();
    },
    refreshApproveEmployeestructuredLearning() {
      const dataArray = this.ListEmployeeStructuredLearning.filter((item) => item.nik === this.nikStructuredLearning);
      this.dataEmployee = dataArray.map((employee) => ({
        employee_name: employee.employee_name,
        employee_nik: employee.employee_nik,
      }));

      this.structuredLearning = dataArray.flatMap((data, dataIndex) => {
        const employeeName = data.employee_name;
        const competencies = data.competency;

        return competencies.flatMap((comp, compIndex) => {
          const gap =
            comp.proficiency > comp.proficiency_standard
              ? comp.proficiency - comp.proficiency_standard
              : comp.proficiency < comp.proficiency_standard
              ? -(comp.proficiency_standard - comp.proficiency)
              : 0;
          const baseComp = {
            competency: comp.competency || null,
            proficiency: comp.proficiency || null,
            proficiency_standard: comp.proficiency_standard || null,
            gap: gap,
            difference: comp.difference || null,
            training_title: null,
            score: null,
            feedback: null,
            proposed_by: null,
            certificate: comp.certificate || null,
            status: null,
            id: null,
            idp_id: null,
            training_type: null,
            training_provider: null,
            price: null,
            training_method: null,
            training_hours: comp.training_hours || null,
          };

          const isFirstCompetency = dataIndex === 0 && compIndex === 0;
          const isFirstInSet = dataIndex > 0 && compIndex === 0;

          if (comp.structured_learning && comp.structured_learning.length > 0) {
            const firstLearningItem = comp.structured_learning[0];
            return [
              {
                ...baseComp,
                competency: comp.competency,
                training_title: firstLearningItem.training_title,
                score: firstLearningItem.score,
                feedback: firstLearningItem.feedback,
                proposed_by: firstLearningItem.proposed_by,
                status: firstLearningItem.status,
                certificate: firstLearningItem.certificate || null,
                id: firstLearningItem.id,
                idp_id: firstLearningItem.idp_id,
                training_type: firstLearningItem.training_type,
                training_provider: firstLearningItem.training_provider,
                price: firstLearningItem.training_price,
                training_method: firstLearningItem.training_method,
                training_hours: firstLearningItem.training_hours,
                training_platform: firstLearningItem.training_platform,
                employee_name: isFirstCompetency || isFirstInSet ? employeeName : null,
              },
              ...comp.structured_learning.slice(1).map((sl) => ({
                ...baseComp,
                competency: null,
                training_title: sl.training_title,
                score: sl.score,
                feedback: sl.feedback,
                proposed_by: sl.proposed_by,
                certificate: sl.certificate || null,
                status: sl.status,
                id: sl.id,
                idp_id: sl.idp_id,
                training_type: sl.training_type,
                training_provider: sl.training_provider,
                price: sl.training_price,
                training_method: sl.training_method,
                training_hours: sl.training_hours,
                training_platform: sl.training_platform,
                employee_name: null,
              })),
            ];
          } else {
            return [
              {
                ...baseComp,
                employee_name: isFirstCompetency || isFirstInSet ? employeeName : null,
              },
            ];
          }
        });
      });
      this.isEmpty = !this.structuredLearning || this.structuredLearning.length === 0;
      this.preselectRows();
    },
    selectEmployeeSocial(e) {
      this.getPersonalData(e.nik);
      this.nikSocial = e.nik;
      this.positionSocial = e.employee_position;
      this.getCompetency(this.nikSocial);
      this.getDataIdpSocial();
      this.checkSocialLearning = [];
      this.sRowSocial = [];
      const dataArray = this.ListDataEmployee.filter((item) => item.nik == e.nik);
      const socialLearningMap = new Map();
      let previousEmployeeName = null;
      dataArray.forEach((data) => {
        const employeeName = data.employee_name;

        if (!socialLearningMap.has(employeeName)) {
          socialLearningMap.set(employeeName, []);
        }

        data.social_learning.forEach((exp) => {
          exp.competency.forEach((comp, index) => {
            const gap =
              comp.proficiency > comp.proficiency_standard
                ? comp.proficiency - comp.proficiency_standard
                : comp.proficiency < comp.proficiency_standard
                ? -(comp.proficiency_standard - comp.proficiency)
                : 0;

            const employeeNameToDisplay = previousEmployeeName !== employeeName ? employeeName : null;

            socialLearningMap.get(employeeName).push({
              competency: comp.name,
              proficiency: comp.proficiency,
              proficiency_standard: comp.proficiency_standard,
              difference: gap,
              id: index === 0 ? exp.id : null,
              idp_id: index === 0 ? exp.idp_id : null,
              coaching_id: index === 0 ? exp.coaching_id : null,
              presentation_document_url: index === 0 ? exp.presentation_document_url : null,
              coaching_title: index === 0 ? exp.coaching_title : null,
              coaching_methodology: index === 0 ? exp.coaching_methodology : null,
              coach_name: index === 0 ? exp.coach_name : null,
              coaching_hour: index === 0 ? exp.coaching_hour : null,
              status: index === 0 ? exp.status : null,
              employee_name: employeeNameToDisplay,
            });

            if (employeeNameToDisplay) {
              previousEmployeeName = employeeName;
            }
          });
        });
      });
      this.socialLearning = Array.from(socialLearningMap.values()).flat();

      // this.$store.dispatch("idpExamination/getIdpExaminationByNik", e.nik)
      //   .then((res) => {
      //     const dataArray = res.data;
      //     const socialLearningMap = new Map();

      //     let previousEmployeeNik = null;

      //     dataArray.forEach((data) => {
      //       const employeeNik = data.nik; // Use `nik` instead of `employee_name`

      //       if (!socialLearningMap.has(employeeNik)) {
      //         socialLearningMap.set(employeeNik, []);
      //       }

      //       if (data.items && data.items.length > 0) {
      //         data.items.forEach((exp, index) => {
      //           const gap = data.proficiency - data.proficiency_standard;
      //           const competencyName = data.competency_name;

      //           const employeeNikToDisplay =
      //             previousEmployeeNik !== employeeNik ? employeeNik : null;

      //           socialLearningMap.get(employeeNik).push({
      //             competency: competencyName,
      //             proficiency: data.proficiency,
      //             proficiency_standard: data.proficiency_standard,
      //             difference: gap,
      //             id: index === 0 ? exp.idp_examination_id : null,
      //             idp_id: index === 0 ? exp.idp_learning_id : null,
      //             coaching_id: index === 0 ? exp.idp_type : null,
      //             presentation_document_url: null, // No such field in your data
      //             coaching_title: index === 0 ? exp.learning.title : null,
      //             coaching_methodology: null, // No such field in your data
      //             coach_name: null, // No such field in your data
      //             coaching_hour: null, // No such field in your data
      //             status: index === 0 ? exp.learning.status : null,
      //             employee_nik: employeeNikToDisplay
      //           });

      //           if (employeeNikToDisplay) {
      //             previousEmployeeNik = employeeNik;
      //           }
      //         });
      //       }
      //     });

      //     this.socialLearning = Array.from(socialLearningMap.values()).flat();

      //   })
    },
    refreshEmployeeSocial() {
      const dataArray = this.ListEmployeeSocial.filter((item) => item.nik === this.nikSocial);
      const socialLearningMap = new Map();

      let previousEmployeeName = null;

      dataArray.forEach((data) => {
        const employeeName = data.employee_name;

        if (!socialLearningMap.has(employeeName)) {
          socialLearningMap.set(employeeName, []);
        }

        data.social_learning.forEach((exp) => {
          exp.competency.forEach((comp, index) => {
            const gap =
              comp.proficiency > comp.proficiency_standard
                ? comp.proficiency - comp.proficiency_standard
                : comp.proficiency < comp.proficiency_standard
                ? -(comp.proficiency_standard - comp.proficiency)
                : 0;

            const employeeNameToDisplay = previousEmployeeName !== employeeName ? employeeName : null;

            socialLearningMap.get(employeeName).push({
              competency: comp.name,
              proficiency: comp.proficiency,
              proficiency_standard: comp.proficiency_standard,
              difference: gap,
              id: index === 0 ? exp.id : null,
              idp_id: index === 0 ? exp.idp_id : null,
              coaching_id: index === 0 ? exp.coaching_id : null,
              presentation_document_url: index === 0 ? exp.presentation_document_url : null,
              coaching_title: index === 0 ? exp.coaching_title : null,
              coaching_methodology: index === 0 ? exp.coaching_methodology : null,
              coach_name: index === 0 ? exp.coach_name : null,
              coaching_hour: index === 0 ? exp.coaching_hour : null,
              status: index === 0 ? exp.status : null,
              employee_name: employeeNameToDisplay,
            });

            if (employeeNameToDisplay) {
              previousEmployeeName = employeeName;
            }
          });
        });
      });

      this.socialLearning = Array.from(socialLearningMap.values()).flat();
    },
    selectEmployeeExperiential(e) {
      this.getPersonalData(e.nik);
      this.nikExperiential = e.nik;
      this.positionExperiential = e.employee_position;
      this.getDataIdpExperiential();
      this.getCompetency(this.nikExperiential);

      const dataArray = this.ListDataEmployee.filter((item) => item.nik == e.nik);
      this.dataEmployee = dataArray.map((employee) => ({
        employee_name: employee.employee_name,
        employee_nik: employee.employee_nik,
      }));

      this.experientialLearning = dataArray.flatMap((data, dataIndex) => {
        const employeeName = data.employee_name;
        const experientialLearningItems = data.experential_learning;
        return experientialLearningItems.flatMap((exp, expIndex) => {
          const baseExp = {
            id: exp.id,
            status: exp.status,
            project_id: exp.project_id,
            notes: exp.notes,
            competency: exp.competency,
            attachments: exp.project?.attachments || null,
            id_project: exp.project?.id || null,
            name: exp.project?.name || null,
            description: exp.project?.description || null,
            start_date: exp.project?.start_date || null,
            end_date: exp.project?.end_date || null,
            duration: exp.project?.duration || null,
            involment: exp.project?.involment || null,
            subordinate: exp.project?.subordinate || null,
            business_need: exp.project?.business_need || null,
            objectives: exp.project?.objectives || null,
            goals: exp.project?.goals || null,
            scope: exp.project?.scope || null,
            constraints: exp.project?.constraints || null,
            deliverables: exp.project?.deliverables || null,
            impact_a: exp.project?.impact_a || null,
            impact: exp.project?.impact || null,
            impact_b: exp.project?.impact_b || null,
            attachments: exp.project?.attachments || null,
            manager_nik: exp.project?.manager_nik || null,
            teams: exp.teams || [],
            created_at: exp.created_at,
          };

          const isFirstExperiential = dataIndex === 0 && expIndex === 0;
          const isFirstInSet = dataIndex > 0 && expIndex === 0;

          if (exp) {
            const firstProjectItem = exp.project;
            return [
              {
                ...baseExp,
                employee_name: isFirstExperiential || isFirstInSet ? employeeName : null,
              },
            ];
          } else {
            return [
              {
                ...baseExp,
                employee_name: isFirstExperiential || isFirstInSet ? employeeName : null,
              },
            ];
          }
        });
      });

      // this.$store.dispatch("idpExamination/getIdpExaminationByNik", e.nik)
      //   .then((res) => {
      //     const dataArray = res.data;
      //     this.dataEmployee = dataArray.map((employee) => ({
      //       employee_name: employee.employee_name,
      //       employee_nik: employee.nik
      //     }));
      //     this.experientialLearning = dataArray.flatMap((data, dataIndex) => {
      //       const employeeName = data.employee_name;
      //       // Ensure items exist and filter only experiential learning
      //       const experientialLearningItems = (data.items || []).filter(
      //         (exp) => exp.idp_type === "experential"
      //       );
      //       // return experientialLearningItems.map((exp, expIndex) => ({
      //       //   id: exp.idp_learning_id,
      //       //   status: exp.learning.status,
      //       //   name: exp.learning.title || null, // Menggunakan "title" karena "name" tidak ada di JSON
      //       //   project_id: exp.project_id || null,
      //       //   notes: exp.notes || null,
      //       //   competency: exp.competency || null,
      //       //   attachments: exp.project?.attachments || null,
      //       //   id_project: exp.project?.id || null,
      //       //   description: exp.project?.description || null,
      //       //   start_date: exp.project?.start_date || null,
      //       //   end_date: exp.project?.end_date || null,
      //       //   duration: exp.project?.duration || null,
      //       //   involment: exp.project?.involment || null,
      //       //   subordinate: exp.project?.subordinate || null,
      //       //   business_need: exp.project?.business_need || null,
      //       //   objectives: exp.project?.objectives || null,
      //       //   goals: exp.project?.goals || null,
      //       //   scope: exp.project?.scope || null,
      //       //   constraints: exp.project?.constraints || null,
      //       //   deliverables: exp.project?.deliverables || null,
      //       //   impact_a: exp.project?.impact_a || null,
      //       //   impact: exp.project?.impact || null,
      //       //   impact_b: exp.project?.impact_b || null,
      //       //   created_at: exp.created_at,
      //       //   employee_name: expIndex === 0 ? employeeName : null // Hanya tampilkan nama di baris pertama
      //       // }));

      //       return experientialLearningItems.map((exp, expIndex) => {
      //         return {
      //           id: exp.idp_learning_id,
      //           status: exp.learning.status,
      //           name: exp.learning.name || null,
      //           project_id: exp.project_id || null,
      //           notes: exp.notes || null,
      //           competency: exp.competency || null,
      //           attachments: exp.project?.attachments || null,
      //           id_project: exp.project?.id || null,
      //           description: exp.project?.description || null,
      //           start_date: exp.project?.start_date || null,
      //           end_date: exp.project?.end_date || null,
      //           duration: exp.project?.duration || null,
      //           involment: exp.project?.involment || null,
      //           subordinate: exp.project?.subordinate || null,
      //           business_need: exp.project?.business_need || null,
      //           objectives: exp.project?.objectives || null,
      //           goals: exp.project?.goals || null,
      //           scope: exp.project?.scope || null,
      //           constraints: exp.project?.constraints || null,
      //           deliverables: exp.project?.deliverables || null,
      //           impact_a: exp.project?.impact_a || null,
      //           impact: exp.project?.impact || null,
      //           impact_b: exp.project?.impact_b || null,
      //           created_at: exp.created_at,
      //           employee_name: expIndex === 0 ? employeeName : null, // Show name only on first row
      //         };
      //       });

      //       // return experientialLearningItems.map((exp, expIndex) => {
      //       //   const baseExp = {
      //       //     id: exp.idp_learning_id,
      //       //     status: exp.learning.status,
      //       //     project_id: exp.project_id || null,
      //       //     notes: exp.notes || null,
      //       //     competency: exp.competency || null,
      //       //     attachments: exp.project?.attachments || null,
      //       //     id_project: exp.project?.id || null,
      //       //     name: exp.learning.title || null, // Menggunakan "title" karena "name" tidak ada di JSON
      //       //     description: exp.project?.description || null,
      //       //     start_date: exp.project?.start_date || null,
      //       //     end_date: exp.project?.end_date || null,
      //       //     duration: exp.project?.duration || null,
      //       //     involment: exp.project?.involment || null,
      //       //     subordinate: exp.project?.subordinate || null,
      //       //     business_need: exp.project?.business_need || null,
      //       //     objectives: exp.project?.objectives || null,
      //       //     goals: exp.project?.goals || null,
      //       //     scope: exp.project?.scope || null,
      //       //     constraints: exp.project?.constraints || null,
      //       //     deliverables: exp.project?.deliverables || null,
      //       //     impact_a: exp.project?.impact_a || null,
      //       //     impact: exp.project?.impact || null,
      //       //     impact_b: exp.project?.impact_b || null,
      //       //     created_at: exp.created_at,
      //       //   };
      //       //   return [
      //       //     {
      //       //       ...baseExp,
      //       //       employee_name:  expIndex === 0 ? employeeName : null
      //       //     }
      //       //   ];
      //       // });
      //     });
      //   })
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    showModalFeedback(item) {
      console.log("isi row buat feedback =>", item);

      const lastIndex = item.feedback.length - 1;
      this.bodyFeedback.id = item.feedback[0]?.id;
      this.bodyFeedback.summary = item.feedback[lastIndex].summary;
      this.bodyFeedback.follow_up = item.feedback[lastIndex].follow_up;
      this.bodyFeedback.feedback = item.feedback[lastIndex].feedback;

      this.isFeedbackSocial = true;
    },
    completedFeedback(item) {
      console.log("isi row buat feedback =>", item);

      const lastIndex = item.feedback.length - 1;
      this.bodyFeedback.id = item.feedback[0]?.id;
      this.bodyFeedback.summary = item.feedback[lastIndex].summary;
      this.bodyFeedback.follow_up = item.feedback[lastIndex].follow_up;
      this.bodyFeedback.feedback = item.feedback[lastIndex].feedback;

      this.feedbackCompleted = true;
    },
    saveSchedule() {
      const scheduleData = this.scheduleList.map((item) => ({
        date: this.$moment(item.date, "DD MMM YYYY").format("YYYY-MM-DD"),
        start_time: this.$moment(item.startTime, "HH:mm").format("HH:mm:ss+07"),
        end_time: this.$moment(item.endTime, "HH:mm").format("HH:mm:ss+07"),
      }));

      const payload = {
        data: scheduleData,
      };

      this.$store
        .dispatch("myIdp/createCoachingSchedule", {
          id: this.idIdpSocial,
          args: payload,
        })
        .then((response) => {
          this.$swal("Success", "Jadwal berhasil disimpan", "success");
          this.isScheduleModalVisible = false;
          this.scheduleList = [];
          this.getScheduleSocial();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal("Error", "Jadwal belum berhasil disimpan", "error");
          console.error("Error saving schedule:", error);
        });
    },
    addSchedule() {
      if (this.schedule.date && this.schedule.startTime && this.schedule.endTime) {
        const formattedSchedule = {
          date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
          startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
          endTime: this.$moment(this.schedule.endTime).format("HH:mm"),
        };
        this.scheduleList.push(formattedSchedule);
        this.clearScheduleModal();
        // this.isScheduleModalVisible = false;
      } else {
        this.$swal("Lengkapi semua kolom");
      }
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    getScheduleSocial() {
      this.$store.dispatch("myIdp/getSocialById", this.idIdpSocial).then((res) => {
        this.scheduleSocial = res.data.schedule;
      });
    },
    setActualStartDate() {
      this.bodyEditActivities.actualStartDate = this.getCurrentDate();
    },

    setActualEndDate() {
      this.bodyEditActivities.actualEndDate = this.getCurrentDate();
    },
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("YYYY-MM-DD");
    },
    submitEditActivities() {
      const formData = new FormData();

      formData.append("id", this.bodyEditActivities.id);
      formData.append("task", this.bodyEditActivities.task);
      formData.append("start_date", this.formatDate(this.bodyEditActivities.startDate));
      formData.append("end_date", this.formatDate(this.bodyEditActivities.endDate));
      formData.append("percentage", this.bodyEditActivities.percentage);
      formData.append("status", this.bodyEditActivities.status);
      formData.append("actual_start_date", this.formatDate(this.bodyEditActivities.actualStartDate));
      formData.append("actual_end_date", this.formatDate(this.bodyEditActivities.actualEndDate));
      formData.append("progress", this.progressPercentage);

      // Attach the file if it exists
      if (this.selectedFile) {
        formData.append("files", this.selectedFile);
      }

      console.log("body edit", formData);

      this.$store
        .dispatch("myIdp/editProjectActivities", {
          id: this.bodyEditActivities.id,
          formData,
        })
        .then((response) => {
          this.$swal("Success", "Milestone proyek berhasil diubah", "success");
          this.isEditActivities = false;
          this.getProjectActivities();
          this.clearBodyActivities();
        })
        .catch((error) => {
          this.$swal("Error", "Gagal mengubah aktivitas: " + (error.response?.data?.message || error.message), "error");
        });
    },
    completeActivities(item) {
      console.log("isinya", item);
      let idActivities = item.id;
      this.$swal({
        title: "Selesaikan Aktivitas",
        text: "Apakah Anda yakin ingin menyelesaikan aktivitas yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeProjectActivities", idActivities)
            .then((response) => {
              this.$swal("Selesai", "Aktivitas Anda telah diselesaikan.", "success");
              this.getProjectActivities();
              this.getDataExperiential();
            })
            .catch((error) => {
              this.$swal("Error", "Aksi gagal. Silakan coba lagi.", "error");
              // console.error("Submission failed:", error);
            });
        }
      });
    },
    deleteActivities(item) {
      console.log("isinya", item);
      let idActivities = item.id;
      this.$swal({
        title: "Hapus Aktivitas",
        text: "Apakah Anda yakin ingin menghapus aktivitas yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/deleteProjectActivities", idActivities)
            .then((response) => {
              this.$swal("Terhapus", "Aktivitas Anda telah dihapus.", "success");
              this.getProjectActivities();
            })
            .catch((error) => {
              this.$swal("Error", "Hapus gagal. Silakan coba lagi.", "error");
              // console.error("Submission failed:", error);
            });
        }
      });
    },
    editActivities(item) {
      console.log("isi row", item);
      this.milestone = item.milestone;

      this.bodyEditActivities.id = item.id;
      this.bodyEditActivities.task = item.task;
      this.bodyEditActivities.startDate = item.start_date;
      this.bodyEditActivities.endDate = item.end_date;
      this.bodyEditActivities.percentage = item.percentage;
      this.bodyEditActivities.status = item.status;
      this.bodyEditActivities.actualStartDate = item.actual_start_date;
      this.bodyEditActivities.actualEndDate = item.actual_end_date;
      this.bodyEditActivities.nik = Array.isArray(item.nik) ? item.nik : [item.nik];
      this.progressPercentage = item.new_progress ? item.new_progress : "0";
      this.isEditActivities = true;
    },
    getBadgeGap(value) {
      if (value > 0) {
        return "badge bg-success";
      } else if (value < 0) {
        return "badge bg-danger";
      } else {
        return "badge bg-success";
      }
    },
    getBadgeResult(value, proficiency_standard) {
      if (value > proficiency_standard) {
        return "badge bg-success";
      } else if (value < proficiency_standard) {
        return "badge bg-danger";
      } else {
        return "badge bg-warning";
      }
    },
    getBadgeGapExam(value) {
      if (value > 0) {
        return "badge bg-danger";
      } else if (value < 0) {
        return "badge bg-success";
      } else if (value == 0) {
        return "badge bg-warning";
      } else {
        return "badge bg-success";
      }
    },
    updateCertificateUrl() {
      this.certificateUrl = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
    },
    clearBodyActivities() {
      this.bodyActivities = {
        id: this.bodyActivities.id,
        id_learning: this.bodyActivities.id_learning,
        task: "",
        startDate: "",
        endDate: "",
        status: "",
      };
      this.bodyEditActivities = {
        task: "",
        startDate: "",
        endDate: "",
        status: "",
        actualStartDate: "",
        actualEndDate: "",
      };
    },
    getProjectActivities() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getProjectByUser", {
          id: this.bodyActivities.id_learning,
        })
        .then((res) => {
          this.isLoading = false;
          console.log();
          this.dataActivities = res.data.activities;
        });
    },
    viewActivities(item) {
      // return console.log(item)
      this.selectedRow = item;
      this.projectStatus = item.status;
      this.bodyActivities.id = item.id;
      this.bodyActivities.id_learning = item.id;
      this.getProjectActivities();
      this.isModalActivities = true;
    },
    approvalProject(item) {
      console.log("isi approval", item);
      this.bodyApproval.id = item.id;
      this.isModalApproval = true;
    },
    resetForm() {
      this.bodyAdd = {
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        website: "",
        contactPerson: "",
        email: "",
        phone: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "",
        price: "",
        description: "",
      };
      this.selectedLearning = null;
      this.$refs.modalTrainingAspiration.hide();
    },
    createTraining() {
      this.$swal({
        title: "Buat Pelatihan",
        text: "Apakah Anda yakin ingin membuat pelatihan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          formData.append("competency", JSON.stringify(this.bodyAdd.competency));
          if (this.bodyAdd.provider !== "Other" && this.selectedLearning) {
            formData.append("provider", this.bodyAdd.provider);
            formData.append("training", this.bodyAdd.training);
            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };
            formData.append("background", JSON.stringify(background));
            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider !== "Other" && !this.selectedLearning) {
            formData.append("provider", this.bodyAdd.provider);

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteProvider,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };
            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));
            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (!this.bodyAdd.provider && !this.selectedLearning) {
            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteTraining,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider == "Other" && !this.selectedLearning) {
            console.log("kondisi 3");
            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteTraining,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider == "Other" && this.selectedLearning) {
            console.log("kondisi 4");

            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          }
          // console.log("req data => ",requestData)
          this.$store
            .dispatch("myIdp/createStructuredLearning", formData)
            .then((response) => {
              this.$swal
                .fire({
                  icon: "success",
                  title: "Success",
                  text: "Aspirasi pelatihan berhasil dibuat.",
                })
                .then(() => {
                  // this.$refs.modalTrainingAspiration.hide();
                  this.getDataIdpManager();
                  this.getDataIdpManagerSocial();
                  this.getDataExperiential();
                  this.resetForm();
                });
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Terjadi kesalahan saat membuat aspirasi pelatihan.",
              });
            });
        }
      });
    },
    selectTraining(training) {
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find((provider) => provider.id === selectedProviderId);
      if (selectedProvider) {
        this.bodyAdd.providerName = selectedProviderId === 0 || selectedProviderId == "Other" ? "" : selectedProvider.name;
        this.bodyAdd.address = selectedProvider.address;
        this.bodyAdd.websiteProvider = selectedProvider.website;
        this.bodyAdd.contactPerson = selectedProvider.contactPerson;
        this.bodyAdd.email = selectedProvider.email;
        this.bodyAdd.phone = selectedProvider.phone;
        if (selectedProviderId === 0 || selectedProviderId == "Other") {
          this.bodyDisAdd.providerName = false;
          this.bodyDisAdd.address = false;
          this.bodyDisAdd.websiteProvider = false;
          this.bodyDisAdd.contactPerson = false;
          this.bodyDisAdd.email = false;
          this.bodyDisAdd.phone = false;
        } else {
          this.bodyDisAdd.providerName = true;
          this.bodyDisAdd.address = true;
          this.bodyDisAdd.websiteProvider = true;
          this.bodyDisAdd.contactPerson = true;
          this.bodyDisAdd.email = true;
          this.bodyDisAdd.phone = true;
        }
        // if (selectedProvider.address || selectedProviderId !== 0) {
        //   this.bodyDisAdd.address = true;
        // }
        // if (selectedProvider.website || selectedProviderId !== 0) {
        //   this.bodyDisAdd.websiteProvider = true;
        // }
        // if (selectedProvider.contactPerson || selectedProviderId !== 0) {
        //   this.bodyDisAdd.contactPerson = true;
        // }
        // if (selectedProvider.email || selectedProviderId !== 0) {
        //   this.bodyDisAdd.email = true;
        // }
        // if (selectedProvider.phone || selectedProviderId !== 0) {
        //   this.bodyDisAdd.phone = true;
        // }
      }
    },
    async fetchProviderByCompetency(competencyId) {
      if (competencyId) {
        try {
          const dataCompetendyId = competencyId?.filter((item) => typeof item === "string").join(",");
          const args = {};
          await this.$store.dispatch("trainingProvider/getProviderByCompentency", dataCompetendyId);
          // console.log(this.$store.state.trainingProvider.trainingByProviderByCompetency);
          this.dataProvider = this.$store.state.trainingProvider.trainingByProviderByCompetency;
          this.dataProvider.push({
            id: "Other",
            name: "Other",
            address: null,
            contact_person: null,
            email: null,
            phone: null,
            website: null,
          });
        } catch (err) {
          this.dataProvider = [];
        }
      } else {
        const competency = "";
        await this.$store.dispatch("trainingProvider/getProviderByCompentency", competency);
        this.dataProvider = this.$store.state.trainingProvider.trainingByProviderByCompetency;
        this.dataProvider.push({
          id: "Other",
          name: "Other",
          address: null,
          contact_person: null,
          email: null,
          phone: null,
          website: null,
        });
        // this.dataProvider = [];
      }
    },
    async fetchTrainingData(providerId) {
      if (providerId && this.bodyAdd.competency) {
        try {
          const dataCompetendyId = this.bodyAdd.competency?.filter((item) => typeof item === "string").join(",");
          await this.$store.dispatch("training/getTrainingByProviderByCompentency", {
            providerId,
            competency: dataCompetendyId,
          });
          this.dataTraining = this.$store.state.training.trainingProviderCompetency;
        } catch (err) {
          console.error(err);
          this.dataTraining = [];
        }
      } else {
        const providerId = "";
        const competency = "";
        await this.$store.dispatch("training/getTrainingByProviderByCompentency", {
          providerId,
          competency: competency,
        });
        this.dataTraining = this.$store.state.training.trainingProviderCompetency;
        // this.dataTraining = [];
      }
    },
    // async fetchTrainingData(providerId) {
    //   if (providerId) {
    //     try {
    //       const args = {};
    //       await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
    //         providerId,
    //         args
    //       });
    //       this.dataTraining =
    //         this.$store.state.trainingProvider.trainingByProvider;
    //     } catch (err) {
    //       console.error(err);
    //       this.dataTraining = [];
    //     }
    //   } else {
    //     this.dataTraining = [];
    //   }
    // },
    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
              providerId: this.bodyAdd.provider,
              search,
            });
            this.dataTraining = this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    formatDateTable(date) {
      if (!date || !this.$moment(date).isValid()) {
        return "-";
      }
      return this.$moment(date).format("DD-MM-YYYY");
    },
    getProjectByUser() {
      this.isLoading = true;
      this.$store.dispatch("project/getProjectByUser", { nik: this.bodyAssign.nik }).then((res) => {
        this.isLoading = false;

        this.projectData = res.data;
        // this.updateCheckedRoles()
      });
    },
    getProjectByUserNik() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getProjectByNik", { nik: this.bodyFeedback.nik })
        .then((res) => {
          this.isLoading = false;
          this.projectUser = res.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },
    updateCheckedRoles() {
      this.checkedRoles = {};

      this.projectData.forEach((item) => {
        item.roles.forEach((role) => {
          role.assignee.forEach((assignee) => {
            this.$set(this.checkedRoles, `${item.project_id}-${role.project_role_name}`, true);
          });
        });
      });
    },

    downloadCertificate() {
      let datas = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
      window.open(datas);
    },
    submitApproval() {
      // const idActivities = item.id;
      // const status =this.bodyApproval.status
      this.$swal({
        title: "Ubah Status Proyek",
        text: `Apakah Anda yakin ingin mengubah status proyek?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/updateProjectStatus", {
              id: this.bodyApproval.id,
              status: this.bodyApproval.status,
              notes: this.bodyApproval.notes,
            })
            .then((response) => {
              this.$swal("Tersimpan", `Status proyek telah diubah.`, "success");
              this.getDataIdpExperiential(this.currentPageExperiential, this.searchExperiential);
              this.bodyApproval.notes = "";
              this.bodyApproval.status = "";
              this.isModalApproval = false;
            })
            .catch((error) => {
              console.error("Error details:", error);
              this.$swal("Error", "Simpan gagal. Silakan coba lagi.", "error");
            });
        }
      });
    },
    submitFeedback() {
      let data = {
        id: this.bodyEditActivities.id,
        feedback: this.bodyFeedback.feedback,
      };
      this.$store
        .dispatch("myIdp/addFeedback", data)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Umpan balik berhasil ditambahkan.",
            })
            .then(() => {
              this.getProjectActivities();
              this.getDataExperiential();
              this.getDataIdpExperiential(this.currentPageExperiential, this.searchExperiential);

              this.isModalFeedbackActivities = false;
              this.isEditActivities = false;

              this.bodyFeedback.feedback = "";
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat menambah umpan balik aktivitas.",
          });
        });
    },
    submitFeedbackSocial() {
      let data = {
        id: this.bodyFeedback.id,
        feedback: this.bodyFeedback.feedback,
      };
      this.$store
        .dispatch("myIdp/addFeedbackCoaching", data)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Umpan balik berhasil ditambahkan.",
            })
            .then(() => {
              this.getDataIdpManagerSocial();
              this.getScheduleSocial();
              this.isFeedbackSocial = false;
              this.bodyFeedback.id = "";
              this.bodyFeedback.feedback = "";
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat menambah umpan balik aktivitas.",
          });
        });
    },
    submitScoreStructured() {
      console.log("idnya", this.bodyScoreStructured.id);
      this.$store
        .dispatch("myIdp/updateScoreStructuredLearning", {
          id: this.bodyScoreStructured.id,
          score: this.bodyScoreStructured.score,
          feedback: this.bodyScoreStructured.feedback,
        })
        .then((response) => {
          this.$swal.fire("Success", "Skor berhasil diperbarui", "success");
          this.isModalScoreStructured = false;
          this.clearUpdateStructured();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal.fire("Error", "Gagal memperbarui skor: " + (error.response?.data?.message || error.message), "error");
        });
    },
    submitAssignee() {
      const data = [];

      this.projectData.forEach((item) => {
        item.roles.forEach((role) => {
          if (this.checkedRoles[item.project_id + "-" + role.project_role_name]) {
            data.push({
              project_id: item.project_id,
              role_id: role.project_role_id,
              nik: this.bodyAssign.nik,
            });
          }
        });
      });

      // Structure the payload
      const payload = {
        data: data,
      };

      this.$store
        .dispatch("myIdp/assignProject", payload)
        .then((response) => {
          this.$swal.fire("Success", "Proyek berhasil di-assign", "success");
          this.isModalAssign = false;
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
          this.getDataExperiential();
          this.checkedRoles = {};
        })
        .catch((error) => {
          this.$swal.fire("Error", "Gagal assign proyek: " + (error.response?.data?.message || error.message), "error");
        });
    },
    submitScoreSocial() {
      this.$store
        .dispatch("myIdp/assignProject", {
          id: this.bodyScoreSocial.id,
          score: this.bodyScoreSocial.score,
          feedback: this.bodyScoreSocial.feedback,
        })
        .then((response) => {
          this.$swal.fire("Success", "Skor berhasil diperbarui", "success");
          this.isModalScoreSocial = false;
          this.clearUpdateSocial();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          this.$swal.fire("Error", "Gagal memperbarui skor: " + (error.response?.data?.message || error.message), "error");
        });
    },
    clearUpdateStructured() {
      (this.bodyScoreStructured.id = ""), (this.bodyScoreStructured.score = ""), (this.bodyScoreStructured.feedback = "");
    },
    clearUpdateSocial() {
      (this.bodyScoreSocial.id = ""), (this.bodyScoreSocial.score = ""), (this.bodyScoreSocial.feedback = "");
    },
    addScoreStructured(item) {
      // console.log("item", item);
      this.bodyScoreStructured.id = item.id;
      this.isModalScoreStructured = true;
    },
    assignProject(item) {
      console.log("isinya ngab", item);
      this.bodyAssign.nik = item.employee_nik;
      this.getProjectByUser();
      this.isModalAssign = true;
    },
    addFeedback(item) {
      // console.log("apalah", item);
      this.bodyFeedback.id = item.id;
      this.isModalFeedbackActivities = true;
    },
    viewFeedback(item) {
      // console.log("apalah", item);
      this.bodyFeedback.viewFeedback = item.feedback;
      this.bodyFeedbackExam = {
        proficiency: item.proficiency_new,
        competency: item.competency_name,
        old_proficiency: item.proficiency,
        standartd_proficiency: item.proficiency_standard,
        feedback: item.feedback,
      };
      this.isModalViewFeedback = true;
    },
    viewProjectList(item) {
      this.bodyFeedback.nik = item.employee_nik;
      console.log("kaskdjqwd", this.bodyFeedback.nik);
      this.getProjectByUserNik();
      this.isModalFeedback = true;
      console.log("isinya", item);
    },
    addScoreSocial(item) {
      // console.log("item", item);
      this.bodyScoreSocial.id = item.id;
      this.isModalScoreSocial = true;
    },
    isCheckboxProject() {
      return true;
    },
    isCheckboxVisible(status) {
      return (
        status !== "approved" &&
        status !== "enrolled" &&
        status !== null &&
        status !== "completed" &&
        status !== "in_review" &&
        status !== "closed" &&
        status !== "enrollment pending"
      );
    },
    preselectRows() {
      this.srStructuredLearning = this.structuredLearning
        .filter((item) => item.status === "draft" || item.status === "submitted")
        .map((item) => item.id);
      this.srSocialLearning = this.socialLearning
        .filter((item) => item.status === "draft" || item.status === "submitted")
        .map((item) => item.id);
    },
    viewDetailStructured(row) {
      this.selectedRowStructured = row;
      this.certificateName = row.certificate;
      this.isModalStructured = true;
      this.updateCertificateUrl();
    },
    viewDetailSocial(row) {
      this.idIdpSocial = row.id;
      this.selectedRowSocial = row;
      // this.certificateName = row.certificate;
      this.isModalSocial = true;
      this.getScheduleSocial();
    },
    clearSelectedRow() {
      this.selectedRowStructured = null;
      this.selectedRowSocial = null;
    },

    getCompetency(nik) {
      console.log("nik", nik);
      this.$store.dispatch("competency/getDataCompetencyByNik", { nik }).then((res) => {
        this.dataCompetency = res.data;
      });
    },
    formatTime(time) {
      return this.$moment(time, "HH:mm:ssZ").format("HH:mm");
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        // console.log("trainMe", res.data);
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        // console.log("trainType", res.data);
        this.dataTrainingType = res.data;
      });
    },
    getProvider() {
      this.$store.dispatch("trainingProvider/getTrainingProviders").then((res) => {
        let data = res.data;
        data.push({
          id: 0,
          name: "Other",
        });
        this.dataProvider = data;
      });
    },
    getDataIdpManager() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;
          this.ListDataEmployee = dataArray;
          // this.ListEmployeeSocial = dataArray;
          // this.ListEmployeeExperiential = dataArray;
          this.refreshEmployeeSocial();
          this.refreshApproveEmployeestructuredLearning();
          // this.dataEmployee = dataArray.map((employee) => ({
          //   employee_name: employee.employee_name,
          //   employee_nik: employee.employee_nik
          // }));

          // this.structuredLearning = dataArray.flatMap((data, dataIndex) => {
          //   const employeeName = data.employee_name;
          //   const competencies = data.competency;

          //   return competencies.flatMap((comp, compIndex) => {
          //     const gap =
          //       comp.proficiency > comp.proficiency_standard
          //         ? comp.proficiency - comp.proficiency_standard
          //         : comp.proficiency < comp.proficiency_standard
          //         ? -(comp.proficiency_standard - comp.proficiency)
          //         : 0;
          //     const baseComp = {
          //       competency: comp.competency || null,
          //       proficiency: comp.proficiency || null,
          //       proficiency_standard: comp.proficiency_standard || null,
          //       gap: gap,
          //       difference: comp.difference || null,
          //       training_title: null,
          //       score: null,
          //       feedback: null,
          //       proposed_by: null,
          //       certificate: comp.certificate || null,
          //       status: null,
          //       id: null,
          //       idp_id: null,
          //       training_type: null,
          //       training_provider: null,
          //       price: null,
          //       training_method: null,
          //       training_hours: comp.training_hours || null
          //     };

          //     const isFirstCompetency = dataIndex === 0 && compIndex === 0;
          //     const isFirstInSet = dataIndex > 0 && compIndex === 0;

          //     if (
          //       comp.structured_learning &&
          //       comp.structured_learning.length > 0
          //     ) {
          //       const firstLearningItem = comp.structured_learning[0];
          //       return [
          //         {
          //           ...baseComp,
          //           competency: comp.competency,
          //           training_title: firstLearningItem.training_title,
          //           score: firstLearningItem.score,
          //           feedback: firstLearningItem.feedback,
          //           proposed_by: firstLearningItem.proposed_by,
          //           status: firstLearningItem.status,
          //           certificate: firstLearningItem.certificate || null,
          //           id: firstLearningItem.id,
          //           idp_id: firstLearningItem.idp_id,
          //           training_type: firstLearningItem.training_type,
          //           training_provider: firstLearningItem.training_provider,
          //           price: firstLearningItem.training_price,
          //           training_method: firstLearningItem.training_method,
          //           training_hours: firstLearningItem.training_hours,
          //           training_platform: firstLearningItem.training_platform,
          //           employee_name:
          //             isFirstCompetency || isFirstInSet ? employeeName : null
          //         },
          //         ...comp.structured_learning.slice(1).map((sl) => ({
          //           ...baseComp,
          //           competency: null,
          //           training_title: sl.training_title,
          //           score: sl.score,
          //           feedback: sl.feedback,
          //           proposed_by: sl.proposed_by,
          //           certificate: sl.certificate || null,
          //           status: sl.status,
          //           id: sl.id,
          //           idp_id: sl.idp_id,
          //           training_type: sl.training_type,
          //           training_provider: sl.training_provider,
          //           price: sl.training_price,
          //           training_method: sl.training_method,
          //           training_hours: sl.training_hours,
          //           training_platform: sl.training_platform,
          //           employee_name: null
          //         }))
          //       ];
          //     } else {
          //       return [
          //         {
          //           ...baseComp,
          //           employee_name:
          //             isFirstCompetency || isFirstInSet ? employeeName : null
          //         }
          //       ];
          //     }
          //   });
          // });
          this.isEmpty = !this.structuredLearning || this.structuredLearning.length === 0;
          // this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    getDataIdpManagerSocial() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;
          this.ListEmployeeSocial = dataArray;
          // const socialLearningMap = new Map();

          // let previousEmployeeName = null;

          // dataArray.forEach((data) => {
          //   const employeeName = data.employee_name;

          //   if (!socialLearningMap.has(employeeName)) {
          //     socialLearningMap.set(employeeName, []);
          //   }

          //   data.social_learning.forEach((exp) => {
          //     exp.competency.forEach((comp, index) => {
          //       const gap =
          //         comp.proficiency > comp.proficiency_standard
          //           ? comp.proficiency - comp.proficiency_standard
          //           : comp.proficiency < comp.proficiency_standard
          //           ? -(comp.proficiency_standard - comp.proficiency)
          //           : 0;

          //       const employeeNameToDisplay =
          //         previousEmployeeName !== employeeName ? employeeName : null;

          //       socialLearningMap.get(employeeName).push({
          //         competency: comp.name,
          //         proficiency: comp.proficiency,
          //         proficiency_standard: comp.proficiency_standard,
          //         difference: gap,
          //         id: index === 0 ? exp.id : null,
          //         idp_id: index === 0 ? exp.idp_id : null,
          //         coaching_id: index === 0 ? exp.coaching_id : null,
          //         presentation_document_url:index === 0 ? exp.presentation_document_url : null,
          //         coaching_title: index === 0 ? exp.coaching_title : null,
          //         coaching_methodology:
          //           index === 0 ? exp.coaching_methodology : null,
          //         coach_name: index === 0 ? exp.coach_name : null,
          //         coaching_hour: index === 0 ? exp.coaching_hour : null,
          //         status: index === 0 ? exp.status : null,
          //         employee_name: employeeNameToDisplay
          //       });

          //       if (employeeNameToDisplay) {
          //         previousEmployeeName = employeeName;
          //       }
          //     });
          //   });
          // });

          // this.socialLearning = Array.from(socialLearningMap.values()).flat();

          this.isEmpty = !this.socialLearning || this.socialLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching social learning data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    getDataExperiential() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpManager")
        .then((res) => {
          const dataArray = res.data;
          // console.log(dataArray)
          this.ListEmployeeExperiential = dataArray;
          // this.dataEmployee = dataArray.map((employee) => ({
          //   employee_name: employee.employee_name,
          //   employee_nik: employee.employee_nik
          // }));

          // this.experientialLearning = dataArray.flatMap((data, dataIndex) => {
          //   const employeeName = data.employee_name;
          //   const experientialLearningItems = data.experential_learning;

          //   return experientialLearningItems.flatMap((exp, expIndex) => {
          //     const baseExp = {
          //       id: exp.id,
          //       status: exp.status,
          //       project_id: exp.project_id,
          //       notes: exp.notes,
          //       competency: exp.competency,
          //       attachments: exp.project?.attachments || null,
          //       id_project: exp.project?.id || null,
          //       name: exp.project?.name || null,
          //       description: exp.project?.description || null,
          //       start_date: exp.project?.start_date || null,
          //       end_date: exp.project?.end_date || null,
          //       duration: exp.project?.duration || null,
          //       involment: exp.project?.involment || null,
          //       subordinate: exp.project?.subordinate || null,
          //       business_need: exp.project?.business_need || null,
          //       objectives: exp.project?.objectives || null,
          //       goals: exp.project?.goals || null,
          //       scope: exp.project?.scope || null,
          //       constraints: exp.project?.constraints || null,
          //       deliverables: exp.project?.deliverables || null,
          //       impact_a: exp.project?.impact_a || null,
          //       impact: exp.project?.impact || null,
          //       impact_b: exp.project?.impact_b || null,
          //       attachments: exp.project?.attachments || null,
          //       created_at: exp.created_at
          //     };

          //     const isFirstExperiential = dataIndex === 0 && expIndex === 0;
          //     const isFirstInSet = dataIndex > 0 && expIndex === 0;

          //     if (exp) {
          //       const firstProjectItem = exp.project;
          //       return [
          //         {
          //           ...baseExp,
          //           employee_name:
          //             isFirstExperiential || isFirstInSet ? employeeName : null
          //         }
          //       ];
          //     } else {
          //       return [
          //         {
          //           ...baseExp,
          //           employee_name:
          //             isFirstExperiential || isFirstInSet ? employeeName : null
          //         }
          //       ];
          //     }
          //   });
          // });

          this.isEmpty = !this.experientialLearning || this.experientialLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching experiential learning data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    initStructuredLearning() {
      this.$store
        .dispatch("myidp/initIdpStructuredLearning")
        .then((res) => {
          // console.log("isi res", res);
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },

    getBadgeSummary(value) {
      if (value === "Completed") {
        return "badge bg-success";
      } else if (value === "In Progress") {
        return "badge bg-warning";
      }
    },
    getBadgeStatus(value) {
      // const status = value.toLowerCase();
      if (value === "completed") {
        return "badge bg-success";
      } else if (value === "draft") {
        return "badge bg-warning";
      } else if (value === "registered") {
        return "badge bg-secondary";
      } else if (value === "rejected") {
        return "badge bg-danger";
      } else if (value === "submitted") {
        return "badge bg-success";
      } else if (value === "approved_manager") {
        return "badge bg-success";
      } else if (value === "approved") {
        return "badge bg-success";
      } else if (value === "enrolled") {
        return "badge bg-success";
      } else if (value === "completed") {
        return "badge bg-info";
      } else if (value === "assigned") {
        return "badge bg-success";
      } else if (value === "to do") {
        return "badge bg-danger";
      } else if (value === "in review") {
        return "badge bg-info";
      } else if (value === "closed") {
        return "badge bg-secondary";
      } else if (value === "revision") {
        return "badge bg-danger";
      } else if (value === "in progress") {
        return "badge bg-warning";
      } else if (value === "scheduled") {
        return "badge bg-warning";
      } else if (value === "enrollment pending") {
        return "badge bg-warning";
      } else if (value === "proposed") {
        return "badge bg-info";
      }
      return "";
    },
    getIconClass(value) {
      if (!value) return "";
      const status = value.toLowerCase();
      switch (status) {
        case "completed":
          return "fe fe-check-circle";
        case "draft":
          return "fe fe-file-text";
        case "registered":
          return "fe fe-user-check";
        case "rejected":
          return "fe fe-x";
        case "submitted":
          return "fe fe-send";
        case "approved_manager":
          return "fe fe-check";
        case "approved":
          return "fe fe-check";
        case "enrolled":
          return "fe fe-user-plus";
        case "assigned":
          return "fe fe-user-check";
        case "in progress":
        case "in_progress":
          return "fe fe-loader";
        case "to do":
        case "to_do":
          return "fe fe-list";
        case "active":
          return "fe fe-activity";
        case "in review":
          return "fe fe-eye";
        case "closed":
          return "fe fe-lock";
        case "submit":
          return "fe fe-arrow-up-circle";
        case "revision":
          return "fe fe-edit";
        case "scheduled":
          return "fe fe-calendar";
        case "enrollment pending":
        case "enrollment_pending":
          return "fe fe-loader";
        case "proposed":
          return "fe fe-loader";
        default:
          return "";
      }
    },
    modifyStatus(status) {
      switch (status) {
        case "submitted":
          return "Waiting Aproval Manager";
        case "approved_manager":
          return "Waiting Aproval HR";
        default:
          return this.capitalizeStatus(status);
      }
    },
    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },

    linkPresentation(link) {
      return `${axiosIns.defaults.baseURL}/presentation/${link}`;
    },

    completeLearning() {
      this.$swal({
        title: "Kirim Coaching?",
        text: "Apakah Anda yakin ingin mengirim coaching ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Kirim",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeReviewSocial", {
              id: this.selectedRowSocial.id,
            })
            .then((resp) => {
              this.isModalSocial = false;
              this.getDataIdpManager();
              this.getDataIdpManagerSocial();
              this.getDataExperiential();
              this.getCompetency();
              this.getProvider();
              this.getTrainingMethod();
              this.getTrainingType();
            })
            .catch((err) => {
              this.$swal(`Gagal`, err.response.data.error, "error");
            });
        }
      });
    },

    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    },
    formatterNumber(val) {
      if (val === "") return "";
      if (!val) return 0;
      return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(?=\d{0,2}$)/g, ",");
    },
    confirmSubmissionStructured() {
      // const approved = this.approvedItems.map((item) => item.id);
      // const rejected = this.rejectedItems.map((item) => item.id);
      const approved = this.checkSTructuredLearning.map((item) => item.id);
      const rejected = [];
      const reqBody = {
        id: approved,
        reject_id: rejected,
        nik: this.nikStructuredLearning,
      };

      this.$store
        .dispatch("myIdp/approveStructuredLearning", reqBody)
        .then((response) => {
          this.$swal("Disetujui", "Pembelajaran Anda telah disetujui.", "success");
          this.$refs.confirmationModalStructured.hide();
          this.getDataIdpManager();
          this.getDataIdpManagerSocial();
          let dataSocial = {
            nik: this.nikSocial,
            employee_position: this.positionSocial,
          };
          let dataStructured = {
            nik: this.nikStructuredLearning,
            employee_position: this.positionStructuredLearning,
          };
          let dataExperiental = {
            nik: this.nikExperiential,
            employee_position: this.positionExperiential,
          };
          setTimeout(() => {
            this.selectEmployeeSocial(dataSocial);
            this.selectEmployeestructuredLearning(dataStructured);
            this.selectEmployeeExperiential(dataExperiental);
          }, 1050);
        })
        .catch((err) => {
          this.$swal(`Gagal`, err.response.data.error, "error");
        });

      this.checkSTructuredLearning = [];
    },
    confirmSubmissionSocial() {
      // console.log("apasps",this.approvedItems)
      // console.log("rejected",this.rejectedItems)
      // const approved = this.approvedItemsSocial.map((item) => item.id);
      // const rejected = this.rejectedItemsSocial.map((item) => item.id);
      const approved = this.checkSocialLearning.map((item) => item.id);
      const rejected = [];
      const reqBody = {
        id: approved,
        reject_id: rejected,
        nik: this.nikSocial,
      };
      this.$store.dispatch("myIdp/approveSocialLearning", reqBody).then((response) => {
        this.$swal("Disetujui", "Pembelajaran Anda telah disetujui.", "success");
        this.$refs.confirmationModalSocial.hide();
        this.getDataIdpManager();
        this.getDataIdpManagerSocial();
        let dataSocial = {
          nik: this.nikSocial,
          employee_position: this.positionSocial,
        };
        let dataStructured = {
          nik: this.nikStructuredLearning,
          employee_position: this.positionStructuredLearning,
        };
        let dataExperiental = {
          nik: this.nikExperiential,
          employee_position: this.positionExperiential,
        };
        setTimeout(() => {
          this.selectEmployeeSocial(dataSocial);
          this.selectEmployeestructuredLearning(dataStructured);
          this.selectEmployeeExperiential(dataExperiental);
        }, 1050);
      });

      this.checkSocialLearning = [];
    },
    submitStructured() {
      const cleanedSelectedRows = this.sRowStructured?.filter((id) => typeof id === "number" && id !== null);
      const preselectedRows = this.srStructuredLearning.filter((id) => typeof id === "number" && id !== null);
      this.approvedItems = this.structuredLearning.filter((item) => cleanedSelectedRows?.includes(item.id));
      this.rejectedItems = this.structuredLearning.filter(
        (item) =>
          // preselectedRows.includes(item.id) &&
          !cleanedSelectedRows?.includes(item.id) &&
          // item.id !== null &&
          (item.status === "submitted" || item.status === "draft")
      );

      this.$refs.confirmationModalStructured.show();
    },
    submitSocial() {
      const cleanedSelectedRows = this.sRowSocial?.filter((id) => typeof id === "number" && id !== null);
      const preselectedRows = this.srSocialLearning.filter((id) => typeof id === "number" && id !== null);
      this.approvedItemsSocial = this.socialLearning.filter((item) => cleanedSelectedRows?.includes(item.id));

      this.rejectedItemsSocial = this.socialLearning.filter(
        (item) =>
          // preselectedRows.includes(item.id) &&
          !cleanedSelectedRows?.includes(item.id) &&
          // item.id !== null &&
          item.status === "submitted"
      );
      this.$refs.confirmationModalSocial.show();
    },
    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to the start of the day
      return date < today; // Disable dates before today
    },
    nextPageStructure() {
      if (this.currentPageStructure < this.totalPagesStructure) {
        this.currentPageStructure = this.currentPageStructure + 1;
        this.getDataIdpStructured();
      }
    },
    prevPageStructure() {
      if (this.currentPageStructure > 1) {
        this.currentPageStructure = this.currentPageStructure - 1;
        this.getDataIdpStructured();
      }
    },
    nextPageSocial() {
      if (this.currentPageSocial < this.totalPagesSocial) {
        this.currentPageSocial = this.currentPageSocial + 1;
        this.getDataIdpSocial();
      }
    },
    prevPageSocial() {
      if (this.currentPageSocial > 1) {
        this.currentPageSocial = this.currentPageSocial - 1;
        this.getDataIdpSocial();
      }
    },
    nextPageExperiential() {
      if (this.currentPageExperiential < this.totalPagesExperiential) {
        this.currentPageExperiential = this.currentPageExperiential + 1;
        this.getDataIdpExperiential();
      }
    },
    prevPageExperiential() {
      if (this.currentPageExperiential > 1) {
        this.currentPageExperiential = this.currentPageExperiential - 1;
        this.getDataIdpExperiential();
      }
    },
    getIdpPeriod() {
      this.$store.dispatch("idpPeriod/getIdpPeriod").then((res) => {
        this.listIdpPeriod = res.data.map((item) => {
          return {
            id: item.id,
            status: item.status,
            label: `${item.start_date} - ${item.end_date}`,
            start_date: item.start_date,
            end_date: item.end_date,
            min_hours: item.min_hours,
          };
        });
      });
    },
    showReportModal() {
      this.isShowReport = true;
    },
    handleExport(data) {
      this.$bvModal.show("modal-loading");

      const type = data.type;
      const startDateLabel = data.start_date ? data.start_date.replace(/-/g, "") : null;
      const endDateLabel = data.end_date ? data.end_date.replace(/-/g, "") : null;
      const name =
        data.status === "enrolled"
          ? "Enrollment-Report.xlsx"
          : getReportFilename(type, startDateLabel, endDateLabel);

      EXPORT_COMMON_REPORT(data)
        .then((resp) => {
          const url = window.URL.createObjectURL(
            new Blob([resp.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.isShowReport = false;
        })
        .catch(async (error) => {
          try {
            if (error.response?.data instanceof Blob) {
              const errText = await error.response.data.text();
              const errJson = JSON.parse(errText);
              this.$swal("Error", errJson.error || errJson.message || "Terjadi kesalahan tak terduga", "error");
            } else {
              const decoder = new TextDecoder("utf-8");
              const errText = decoder.decode(error.response?.data);
              const errJson = JSON.parse(errText);
              this.$swal("Error", errJson.error || "Terjadi kesalahan tak terduga", "error");
            }
          } catch (e) {
            this.$swal("Error", error.message || "Terjadi kesalahan", "error");
          }
        })
        .finally(() => {
          this.$bvModal.hide("modal-loading");
        });
    },
  },

  mounted() {
    const roleLogin = this.roleLogin;
    if (roleLogin && roleLogin.includes("HR")) {
      this.getAllEmployees();
    } else {
      this.getEmployee();
    }
    // this.getAllEmployees();
    this.getDataIdpManager();
    // this.getDataIdpManagerSocial();
    // this.getDataExperiential();
    this.getCompetency();
    // this.getProvider();
    this.getTrainingMethod();
    this.getTrainingType();
    // this.getEmployee();
    this.getIdpPeriod();

    const listMenu = JSON.parse(localStorage.getItem("listMenu") || []);
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find(
      (menu) => menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  },
};
</script>

<style>
.pagination-controls {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 15px;
}
.pagination-controls label {
  margin-right: 10px;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.pagination button {
  margin: 0 5px;
}
.table-responsive::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}
.table-responsive {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.rectangle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5px;
}
.rectangle {
  width: 15px;
  height: 10px;
  background-color: #e0e0e0;
  border: 1px solid #ccc;
}
.rectangle.filled-danger {
  background-color: #e63757;
}
.rectangle.filled-target {
  background-color: #f6c343;
}
.rectangle.filled-achievement {
  background-color: #00d97e;
}
</style>
